export default{
regionData:[
["2508","450702","钦南区","259"],//ID,行政编码,行政名称,父级ID
["2514","450803","港南区","260"],
["2522","450923","博白县","261"],
["2527","451021","田阳县","262"],
["2531","451025","靖西县","262"],
["2534","451028","乐业县","262"],
["2537","451031","隆林各族自治县","262"],
["2542","451123","富川瑶族自治县","263"],
["2549","451225","罗城仫佬族自治县","264"],
["2551","451227","巴马瑶族自治县","264"],
["2554","451281","宜州市","264"],
["2559","451323","武宣县","265"],
["2561","451381","合山市","265"],
["2565","451422","宁明县","266"],
["1648","360481","瑞昌市","162"],
["1650","360502","渝水区","163"],
["1651","360521","分宜县","163"],
["1652","360601","市辖区","164"],
["1654","360622","余江县","164"],
["1655","360681","贵溪市","164"],
["1656","360701","市辖区","165"],
["1658","360721","赣县","165"],
["1659","360722","信丰县","165"],
["1660","360723","大余县","165"],
["1662","360725","崇义县","165"],
["1663","360726","安远县","165"],
["1664","360727","龙南县","165"],
["1666","360729","全南县","165"],
["1667","360730","宁都县","165"],
["1668","360731","于都县","165"],
["1670","360733","会昌县","165"],
["1671","360734","寻乌县","165"],
["1672","360735","石城县","165"],
["1674","360782","南康市","165"],
["1675","360801","市辖区","166"],
["1676","360802","吉州区","166"],
["1678","360821","吉安县","166"],
["1679","360822","吉水县","166"],
["1680","360823","峡江县","166"],
["1682","360825","永丰县","166"],
["1683","360826","泰和县","166"],
["1684","360827","遂川县","166"],
["1686","360829","安福县","166"],
["1687","360830","永新县","166"],
["1688","360881","井冈山市","166"],
["1690","360902","袁州区","167"],
["1691","360921","奉新县","167"],
["1692","360922","万载县","167"],
["1694","360924","宜丰县","167"],
["1695","360925","靖安县","167"],
["1696","360926","铜鼓县","167"],
["1697","360981","丰城市","167"],
["1698","360982","樟树市","167"],
["1699","360983","高安市","167"],
["1700","361001","市辖区","168"],
["1701","361002","临川区","168"],
["1702","361021","南城县","168"],
["1703","361022","黎川县","168"],
["1704","361023","南丰县","168"],
["1705","361024","崇仁县","168"],
["1706","361025","乐安县","168"],
["1707","361026","宜黄县","168"],
["1708","361027","金溪县","168"],
["1709","361028","资溪县","168"],
["1710","361029","东乡县","168"],
["1711","361030","广昌县","168"],
["1712","361101","市辖区","169"],
["1713","361102","信州区","169"],
["1714","361121","上饶县","169"],
["1715","361122","广丰县","169"],
["1716","361123","玉山县","169"],
["1717","361124","铅山县","169"],
["1718","361125","横峰县","169"],
["1719","361126","弋阳县","169"],
["1720","361127","余干县","169"],
["1721","361128","鄱阳县","169"],
["1722","361129","万年县","169"],
["1723","361130","婺源县","169"],
["1724","361181","德兴市","169"],
["1725","370101","市辖区","170"],
["1726","370102","历下区","170"],
["1727","370101","市中区","170"],
["1728","370104","槐荫区","170"],
["1729","370105","天桥区","170"],
["1730","370112","历城区","170"],
["1731","370113","长清区","170"],
["1732","370124","平阴县","170"],
["1733","370125","济阳县","170"],
["1734","370126","商河县","170"],
["1735","370181","章丘市","170"],
["1736","370201","市辖区","171"],
["1737","370202","市南区","171"],
["1738","370203","市北区","171"],
["1739","370205","四方区","171"],
["1740","370211","黄岛区","171"],
["1741","370212","崂山区","171"],
["1742","370213","李沧区","171"],
["1743","370214","城阳区","171"],
["1744","370281","胶州市","171"],
["1745","370282","即墨市","171"],
["1746","370283","平度市","171"],
["1747","370284","胶南市","171"],
["1748","370285","莱西市","171"],
["1749","370301","市辖区","172"],
["1750","370302","淄川区","172"],
["1751","370303","张店区","172"],
["1752","370304","博山区","172"],
["1753","370305","临淄区","172"],
["1754","370306","周村区","172"],
["1755","370321","桓台县","172"],
["1756","370322","高青县","172"],
["1758","370401","市辖区","173"],
["1759","370402","市中区","173"],
["1760","370403","薛城区","173"],
["1761","370404","峄城区","173"],
["1763","370406","山亭区","173"],
["1764","370481","滕州市","173"],
["1765","370501","市辖区","174"],
["1766","370502","东营区","174"],
["1768","370521","垦利县","174"],
["1769","370522","利津县","174"],
["1771","370601","市辖区","175"],
["1772","370602","芝罘区","175"],
["1773","370611","福山区","175"],
["1774","370612","牟平区","175"],
["1775","370613","莱山区","175"],
["1777","370681","龙口市","175"],
["1778","370682","莱阳市","175"],
["1780","370684","蓬莱市","175"],
["1781","370685","招远市","175"],
["1783","370687","海阳市","175"],
["1784","370701","市辖区","176"],
["1785","370702","潍城区","176"],
["1786","370703","寒亭区","176"],
["1788","370705","奎文区","176"],
["1789","370724","临朐县","176"],
["1791","370781","青州市","176"],
["1792","370782","诸城市","176"],
["1794","370784","安丘市","176"],
["1795","370785","高密市","176"],
["1796","370786","昌邑市","176"],
["1797","370801","市辖区","177"],
["1798","370802","市中区","177"],
["1800","370826","微山县","177"],
["1801","370827","鱼台县","177"],
["1802","370828","金乡县","177"],
["1804","370830","汶上县","177"],
["1805","370831","泗水县","177"],
["1807","370881","曲阜市","177"],
["1808","370882","兖州市","177"],
["1810","370901","市辖区","178"],
["1811","370902","泰山区","178"],
["1812","370911","岱岳区","178"],
["1813","370921","宁阳县","178"],
["1814","370923","东平县","178"],
["1816","370983","肥城市","178"],
["1817","371001","市辖区","179"],
["1818","371002","环翠区","179"],
["1820","371082","荣成市","179"],
["1821","371083","乳山市","179"],
["1822","371101","市辖区","180"],
["1823","371102","东港区","180"],
["1824","371103","岚山区","180"],
["1825","371121","五莲县","180"],
["1827","371201","市辖区","181"],
["1828","371202","莱城区","181"],
["3457","652826","焉耆回族自治县","369"],
["3458","652827","和静县","369"],
["3459","652828","和硕县","369"],
["3460","652829","博湖县","369"],
["3462","652922","温宿县","370"],
["3463","652923","库车县","370"],
["3464","652924","沙雅县","370"],
["3465","652925","新和县","370"],
["3466","652926","拜城县","370"],
["3467","652927","乌什县","370"],
["3468","652928","阿瓦提县","370"],
["3469","652929","柯坪县","370"],
["3470","653001","阿图什市","371"],
["3471","653022","阿克陶县","371"],
["3473","653024","乌恰县","371"],
["3474","653101","喀什市","372"],
["3475","653121","疏附县","372"],
["3477","653123","英吉沙县","372"],
["3478","653124","泽普县","372"],
["3479","653125","莎车县","372"],
["3481","653127","麦盖提县","372"],
["3482","653128","岳普湖县","372"],
["3484","653130","巴楚县","372"],
["3486","653201","和田市","373"],
["3487","653221","和田县","373"],
["3488","653222","墨玉县","373"],
["3489","653223","皮山县","373"],
["3490","653224","洛浦县","373"],
["3491","653225","策勒县","373"],
["3492","653226","于田县","373"],
["3493","653227","民丰县","373"],
["3495","654003","奎屯市","374"],
["3496","654021","伊宁县","374"],
["3498","654023","霍城县","374"],
["3499","654024","巩留县","374"],
["3500","654025","新源县","374"],
["3501","654026","昭苏县","374"],
["3502","654027","特克斯县","374"],
["3503","654028","尼勒克县","374"],
["3505","654202","乌苏市","375"],
["3506","654221","额敏县","375"],
["3507","654223","沙湾县","375"],
["3509","654225","裕民县","375"],
["3511","654301","阿勒泰市","376"],
["3512","654321","布尔津县","376"],
["3513","654322","富蕴县","376"],
["3514","654323","福海县","376"],
["3515","654324","哈巴河县","376"],
["3516","654325","青河县","376"],
["3518","659001","石河子市","377"],
["3519","659002","阿拉尔市","377"],
["3521","659004","五家渠市","377"],
["109","320100","南京市","11"],
["112","320400","常州市","11"],
["116","320800","淮安市","11"],
["120","321200","泰州市","11"],
["123","330200","宁波市","12"],
["127","330600","绍兴市","12"],
["131","331000","台州市","12"],
["135","340300","蚌埠市","13"],
["138","340600","淮北市","13"],
["142","341100","滁州市","13"],
["146","341500","六安市","13"],
["150","350100","福州市","14"],
["153","350400","三明市","14"],
["157","350800","龙岩市","14"],
["161","360300","萍乡市","15"],
["164","360600","鹰潭市","15"],
["168","361000","抚州市","15"],
["172","370300","淄博市","16"],
["176","370700","潍坊市","16"],
["180","371100","日照市","16"],
["183","371400","德州市","16"],
["187","410100","郑州市","17"],
["191","410500","安阳市","17"],
["194","410800","焦作市","17"],
["198","411200","三门峡市","17"],
["202","411600","周口市","17"],
["206","420300","十堰市","18"],
["210","420800","荆门市","18"],
["213","421100","黄冈市","18"],
["216","422800","恩施土家族苗族自治州","18"],
["221","430400","衡阳市","19"],
["224","430700","常德市","19"],
["228","431100","永州市","19"],
["231","433100","湘西土家族苗族自治州","19"],
["240","440900","茂名市","20"],
["244","441500","汕尾市","20"],
["289","511900","巴中市","24"],
["420","130108","裕华区","37"],
["423","130124","栾城县","37"],
["427","130128","深泽县","37"],
["435","130183","晋州市","37"],
["439","130202","路南区","38"],
["443","130207","丰南区","38"],
["447","130225","乐亭县","38"],
["455","130303","山海关区","39"],
["464","130404","复兴区","40"],
["467","130423","临漳县","40"],
["472","130428","肥乡县","40"],
["476","130432","广平县","40"],
["484","130521","邢台县","41"],
["488","130525","隆尧县","41"],
["496","130533","威县","41"],
["499","130581","南宫市","41"],
["507","130623","涞水县","42"],
["511","130627","唐县","42"],
["518","130634","曲阳县","42"],
["523","130681","涿州市","42"],
["531","130706","下花园区","43"],
["535","130724","沽源县","43"],
["539","130728","怀安县","43"],
["547","130803","双滦区","44"],
["549","130821","承德县","44"],
["553","130825","隆化县","44"],
["558","130902","新华区","45"],
["563","130924","海兴县","45"],
["566","130927","南皮县","45"],
["741","150205","石拐区","60"],
["744","150221","土默特右旗","60"],
["747","150301","市辖区","61"],
["750","150304","乌达区","61"],
["753","150403","元宝山区","62"],
["764","150501","市辖区","63"],
["766","150521","科尔沁左翼中旗","63"],
["771","150526","扎鲁特旗","63"],
["777","150624","鄂托克旗","64"],
["781","150701","市辖区","65"],
["787","150725","陈巴尔虎旗","65"],
["790","150781","满洲里市","65"],
["793","150784","额尔古纳市","65"],
["798","150822","磴口县","66"],
["801","150825","乌拉特后旗","66"],
["805","150921","卓资县","67"],
["811","150927","察哈尔右翼中旗","67"],
["820","152224","突泉县","68"],
["826","152525","东乌珠穆沁旗","69"],
["833","152921","阿拉善左旗","70"],
["836","210101","市辖区","71"],
["840","210105","皇姑区","71"],
["843","210112","东陵区","71"],
["850","210201","市辖区","72"],
["995","220623","长白朝鲜族自治县","90"],
["1000","220721","前郭尔罗斯蒙古族自治县","91"],
["1011","222402","图们市","93"],
["1015","222406","和龙市","93"],
["1019","230102","道里区","94"],
["1026","230111","呼兰区","94"],
["1031","230127","木兰县","94"],
["1034","230112","阿城区","94"],
["1038","230201","市辖区","95"],
["1045","230208","梅里斯达斡尔族区","95"],
["1051","230229","克山县","95"],
["1055","230301","市辖区","96"],
["1058","230304","滴道区","96"],
["1062","230321","鸡东县","96"],
["1066","230402","向阳区","97"],
["1073","230422","绥滨县","97"],
["1077","230505","四方台区","98"],
["1081","230523","宝清县","98"],
["1088","230606","大同区","99"],
["1098","230706","翠峦区","100"],
["1102","230710","五营区","100"],
["1105","230713","带岭区","100"],
["1108","230716","上甘岭区","100"],
["1121","230881","同江市","101"],
["1125","230903","桃山区","102"],
["1128","231001","市辖区","103"],
["1132","231005","西安区","103"],
["1297","321324","泗洪县","121"],
["1301","330104","江干区","122"],
["1305","330109","萧山区","122"],
["1309","330182","建德市","122"],
["1313","330203","海曙区","123"],
["1317","330211","镇海区","123"],
["1321","330281","余姚市","123"],
["1325","330302","鹿城区","124"],
["1329","330324","永嘉县","124"],
["1333","330329","泰顺县","124"],
["1341","330481","海宁市","125"],
["1345","330502","吴兴区","126"],
["1349","330523","安吉县","126"],
["1353","330624","新昌县","127"],
["1357","330701","市辖区","128"],
["1361","330726","浦江县","128"],
["1365","330783","东阳市","128"],
["1369","330803","衢江区","129"],
["1373","330881","江山市","129"],
["1377","330921","岱山县","130"],
["1381","331003","黄岩区","131"],
["1385","331023","天台县","131"],
["1389","331101","市辖区","132"],
["1393","331123","遂昌县","132"],
["1397","331127","景宁畲族自治县","132"],
["1403","340111","包河区","133"],
["1407","340201","市辖区","1412"],
["1411","340207","鸠江区","1412"],
["1581","350626","东山县","155"],
["1585","350681","龙海市","155"],
["1589","350722","浦城县","156"],
["1593","350781","邵武市","156"],
["1597","350801","市辖区","157"],
["1601","350823","上杭县","157"],
["1605","350901","市辖区","158"],
["1609","350923","屏南县","158"],
["1613","350981","福安市","158"],
["1617","360103","西湖区","159"],
["1620","360111","青山湖区","159"],
["1625","360201","市辖区","160"],
["1629","360281","乐平市","160"],
["1633","360321","莲花县","161"],
["1637","360402","庐山区","162"],
["1641","360424","修水县","162"],
["1645","360428","都昌县","162"],
["1649","360501","市辖区","163"],
["1653","360602","月湖区","164"],
["1657","360702","章贡区","165"],
["1661","360724","上犹县","165"],
["1665","360728","定南县","165"],
["1669","360732","兴国县","165"],
["1673","360781","瑞金市","165"],
["1677","360803","青原区","166"],
["1681","360824","新干县","166"],
["1685","360828","万安县","166"],
["1689","360901","市辖区","167"],
["1693","360923","上高县","167"],
["1857","371521","阳谷县","184"],
["1862","371526","高唐县","184"],
["1866","371621","惠民县","185"],
["1870","371625","博兴县","185"],
["1875","371722","单县","186"],
["1878","371725","郓城县","186"],
["1882","410101","市辖区","187"],
["1885","410104","管城回族区","187"],
["1891","410182","荥阳市","187"],
["1895","410201","市辖区","188"],
["1903","410223","尉氏县","188"],
["1907","410302","老城区","189"],
["1910","410305","涧西区","189"],
["1914","410323","新安县","189"],
["1919","410328","洛宁县","189"],
["1923","410402","新华区","190"],
["1927","410421","宝丰县","190"],
["1931","410481","舞钢市","190"],
["1935","410503","北关区","191"],
["1939","410523","汤阴县","191"],
["1944","410602","鹤山区","192"],
["1949","410701","市辖区","193"],
["1953","410711","牧野区","193"],
["1957","410726","延津县","193"],
["1961","410782","辉县市","193"],
["1965","410804","马村区","194"],
["1969","410823","武陟县","194"],
["1973","410883","孟州市","194"],
["2136","421081","石首市","212"],
["2140","421102","黄州区","213"],
["2144","421124","英山县","213"],
["2148","421181","麻城市","213"],
["2152","421221","嘉鱼县","214"],
["2156","421281","赤壁市","214"],
["2160","422801","恩施市","216"],
["2164","422825","宣恩县","216"],
["2168","429004","仙桃市","217"],
["2171","429021","神农架林区","217"],
["2177","430111","雨花区","218"],
["2181","430181","浏阳市","218"],
["2185","430204","石峰区","219"],
["2189","430224","茶陵县","219"],
["2193","430302","雨湖区","220"],
["2197","430382","韶山市","220"],
["2201","430407","石鼓区","221"],
["2205","430422","衡南县","221"],
["2213","430503","大祥区","222"],
["2217","430523","邵阳县","222"],
["2221","430528","新宁县","222"],
["2227","430611","君山区","223"],
["2231","430626","平江县","223"],
["2239","430723","澧县","224"],
["2243","430781","津市市","224"],
["2251","430903","赫山区","226"],
["2405","441501","市辖区","244"],
["2409","441581","陆丰市","244"],
["2413","441622","龙川县","245"],
["2417","441701","市辖区","246"],
["2425","441823","阳山县","247"],
["2427","441826","连南瑶族自治县","247"],
["2433","445121","潮安县","250"],
["2441","445301","市辖区","252"],
["2445","445323","云安县","252"],
["2449","450103","青秀区","253"],
["2452","450108","良庆区","253"],
["2456","450124","马山县","253"],
["2461","450202","城中区","254"],
["2465","450221","柳江县","254"],
["2473","450303","叠彩区","255"],
["2477","450321","阳朔县","255"],
["2481","450325","兴安县","255"],
["2489","450401","市辖区","256"],
["2493","450421","苍梧县","256"],
["2497","450501","市辖区","257"],
["2501","450521","合浦县","257"],
["2505","450621","上思县","258"],
["2513","450802","港北区","260"],
["2517","450881","桂平市","260"],
["2525","451001","市辖区","262"],
["2648","510129","大邑县","273"],
["2651","510181","都江堰市","273"],
["2656","510302","自流井区","274"],
["2666","510421","米易县","275"],
["2670","510503","纳溪区","276"],
["2674","510524","叙永县","276"],
["2682","510683","绵竹市","277"],
["2686","510722","三台县","278"],
["2690","510726","北川羌族自治县","278"],
["2700","510824","苍溪县","279"],
["2704","510921","蓬溪县","280"],
["2708","511002","市中区","281"],
["2716","511112","五通桥区","282"],
["2720","511126","夹江县","282"],
["2727","511303","高坪区","283"],
["2731","511323","蓬安县","283"],
["2735","511401","市辖区","284"],
["2739","511423","洪雅县","284"],
["2743","511502","翠屏区","285"],
["2752","511529","屏山县","285"],
["2756","511622","武胜县","286"],
["2760","511702","通川区","287"],
["2769","511821","名山县","288"],
["2773","511825","天全县","288"],
["2777","511902","巴州区","289"],
["2781","512001","市辖区","290"],
["2790","513225","九寨沟县","291"],
["2794","513229","马尔康县","291"],
["2935","530126","石林彝族自治县","303"],
["2947","530326","会泽县","304"],
["2951","530402","红塔区","305"],
["2955","530424","华宁县","305"],
["2959","530428","元江哈尼族彝族傣族自治县","305"],
["2969","530622","巧家县","307"],
["2977","530630","水富县","307"],
["2980","530721","玉龙纳西族自治县","308"],
["514","130630","涞源县","42"],
["2989","530824","景谷傣族彝族自治县","309"],
["2991","530826","江城哈尼族彝族自治县","309"],
["2993","530828","澜沧拉祜族自治县","309"],
["2999","530923","永德县","310"],
["3001","530925","双江拉祜族佤族布朗族傣族自治县","310"],
["3008","532325","姚安县","311"],
["3012","532329","武定县","311"],
["3016","532503","蒙自市","312"],
["3019","532525","石屏县","312"],
["3023","532529","红河县","312"],
["3024","532530","金平苗族瑶族傣族自治县","312"],
["3033","532627","广南县","313"],
["3037","532823","勐腊县","314"],
["3039","532922","漾濞彝族自治县","315"],
["3044","532927","巍山彝族回族自治县","315"],
["3050","533102","瑞丽市","316"],
["3054","533124","陇川县","316"],
["3057","533324","贡山独龙族怒族自治县","317"],
["3222","610802","榆阳区","333"],
["3226","610824","靖边县","333"],
["3230","610828","佳县","333"],
["3234","610901","市辖区","334"],
["3238","610923","宁陕县","334"],
["3242","610927","镇坪县","334"],
["3246","611002","商州区","335"],
["3250","611024","山阳县","335"],
["3254","620102","城关区","336"],
["3257","620105","安宁区","336"],
["3261","620123","榆中县","336"],
["3265","620321","永昌县","338"],
["3269","620421","靖远县","339"],
["3277","620523","甘谷县","340"],
["3279","620525","张家川回族自治县","340"],
["3286","620702","甘州区","342"],
["3288","620722","民乐县","342"],
["3292","620801","市辖区","343"],
["3296","620823","崇信县","343"],
["3300","620901","市辖区","344"],
["3305","620924","阿克塞哈萨克族自治县","344"],
["3313","621024","合水县","345"],
["3317","621101","市辖区","346"],
["3321","621123","渭源县","346"],
["3326","621202","武都区","347"],
["3331","621225","西和县","347"],
["3472","653023","阿合奇县","371"],
["3476","653122","疏勒县","372"],
["3480","653126","叶城县","372"],
["3483","653129","伽师县","372"],
["3485","653131","塔什库尔干塔吉克自治县","372"],
["3494","654002","伊宁市","374"],
["3497","654022","察布查尔锡伯自治县","374"],
["3504","654201","塔城市","375"],
["3508","654224","托里县","375"],
["3510","654226","和布克赛尔蒙古自治县","375"],
["3517","654326","吉木乃县","376"],
["3520","659003","图木舒克市","377"],
["7","210000","辽宁省","1"],
["11","320000","江苏省","1"],
["15","360000","江西省","1"],
["19","430000","湖南省","1"],
["25","520000","贵州省","1"],
["30","630000","青海省","1"],
["23","500000","重庆市","1"],
["526","130684","高碑店市","42"],
["543","130732","赤城县","43"],
["555","130827","宽城满族自治县","44"],
["569","130930","孟村回族自治县","45"],
["760","150426","翁牛特旗","62"],
["774","150621","达拉特旗","64"],
["784","150722","莫力达瓦达斡尔族自治旗","65"],
["809","150925","凉城县","67"],
["814","150981","丰镇市","67"],
["822","152502","锡林浩特市","69"],
["829","152528","镶黄旗","69"],
["847","210123","康平县","71"],
["1007","220822","通榆县","92"],
["1042","230205","昂昂溪区","95"],
["1069","230405","兴安区","97"],
["1085","230603","龙凤区","99"],
["1092","230624","杜尔伯特蒙古族自治县","99"],
["1117","230822","桦南县","101"],
["2209","430481","耒阳市","221"],
["2223","430581","武冈市","222"],
["2235","430702","武陵区","224"],
["2246","430811","武陵源区","225"],
["2421","441781","阳春市","246"],
["2437","445221","揭东县","251"],
["2469","450225","融水苗族自治县","254"],
["2484","450328","龙胜各族自治县","255"],
["2509","450703","钦北区","259"],
["2521","450922","陆川县","261"],
["2661","510322","富顺县","274"],
["2678","510623","中江县","277"],
["2696","510812","朝天区","279"],
["2712","511028","隆昌县","281"],
["2722","511132","峨边彝族自治县","282"],
["2747","511524","长宁县","285"],
["2764","511724","大竹县","287"],
["2785","512081","简阳市","290"],
["2933","530124","富民县","303"],
["2938","530129","寻甸回族彝族自治县","303"],
["2957","530426","峨山彝族自治县","305"],
["2973","530626","绥江县","307"],
["2986","530821","宁洱哈尼族彝族自治县","309"],
["1757","370323","沂源县","172"],
["1762","370405","台儿庄区","173"],
["1767","370503","河口区","174"],
["1770","370523","广饶县","174"],
["1776","370634","长岛县","175"],
["1779","370683","莱州市","175"],
["1782","370686","栖霞市","175"],
["186","371700","菏泽市","16"],
["1787","370704","坊子区","176"],
["2645","510121","金堂县","273"],
["2650","510132","新津县","273"],
["2654","510184","崇州市","273"],
["2663","510402","东区","275"],
["2669","510502","江阳区","276"],
["2675","510525","古蔺县","276"],
["2680","510681","广汉市","277"],
["2685","510704","游仙区","278"],
["2691","510727","平武县","278"],
["2697","510821","旺苍县","279"],
["2705","510922","射洪县","280"],
["2711","511025","资中县","281"],
["2718","511123","犍为县","282"],
["2723","511133","马边彝族自治县","282"],
["2730","511322","营山县","283"],
["2734","511381","阆中市","283"],
["2740","511424","丹棱县","284"],
["2746","511523","江安县","285"],
["2750","511527","筠连县","285"],
["2757","511623","邻水县","286"],
["2763","511723","开江县","287"],
["2771","511823","汉源县","288"],
["2775","511827","宝兴县","288"],
["2780","511923","平昌县","289"],
["2787","513222","理县","291"],
["2791","513226","金川县","291"],
["2795","513230","壤塘县","291"],
["2798","513233","红原县","291"],
["2800","513322","泸定县","292"],
["2802","513324","九龙县","292"],
["2879","522229","松桃苗族自治县","298"],
["2883","522323","普安县","299"],
["2886","522326","望谟县","299"],
["2889","522401","毕节市","300"],
["2892","522424","金沙县","300"],
["2895","522427","威宁彝族回族苗族自治县","300"],
["2900","522624","三穗县","301"],
["2903","522627","天柱县","301"],
["2906","522630","台江县","301"],
["2909","522633","从江县","301"],
["2913","522701","都匀市","302"],
["2916","522723","贵定县","302"],
["2920","522728","罗甸县","302"],
["2923","522731","惠水县","302"],
["2926","530102","五华区","303"],
["2930","530113","东川区","303"],
["2934","530125","宜良县","303"],
["2937","530128","禄劝彝族苗族自治县","303"],
["2945","530324","罗平县","304"],
["2949","530381","宣威市","304"],
["2954","530423","通海县","305"],
["2958","530427","新平彝族傣族自治县","305"],
["2968","530621","鲁甸县","307"],
["2972","530625","永善县","307"],
["2976","530629","威信县","307"],
["2983","530724","宁蒗彝族自治县","308"],
["2988","530823","景东彝族自治县","309"],
["2992","530827","孟连傣族拉祜族佤族自治县","309"],
["3002","530926","耿马傣族佤族自治县","310"],
["3005","532322","双柏县","311"],
["3010","532327","永仁县","311"],
["3014","532501","个旧市","312"],
["3017","532523","屏边苗族自治县","312"],
["3103","542330","仁布县","322"],
["3106","542333","仲巴县","322"],
["3108","542335","吉隆县","322"],
["3112","542421","那曲县","323"],
["3116","542425","安多县","323"],
["3119","542428","班戈县","323"],
["3123","542522","札达县","324"],
["3127","542526","改则县","324"],
["3130","542622","工布江达县","325"],
["3133","542625","波密县","325"],
["3140","610111","灞桥区","326"],
["3144","610115","临潼区","326"],
["3148","610125","户县","326"],
["3156","610302","渭滨区","328"],
["3160","610323","岐山县","328"],
["3164","610328","千阳县","328"],
["3169","610402","秦都区","329"],
["3173","610423","泾阳县","329"],
["3176","610426","永寿县","329"],
["3180","610430","淳化县","329"],
["3185","610521","华县","330"],
["3188","610524","合阳县","330"],
["3191","610527","白水县","330"],
["3194","610582","华阴市","330"],
["3199","610623","子长县","331"],
["3202","610626","吴起县","331"],
["3206","610630","宜川县","331"],
["3208","610632","黄陵县","331"],
["1790","370725","昌乐县","176"],
["1793","370783","寿光市","176"],
["1799","370811","任城区","177"],
["1803","370829","嘉祥县","177"],
["1806","370832","梁山县","177"],
["1809","370883","邹城市","177"],
["1815","370982","新泰市","178"],
["1819","371081","文登市","179"],
["1826","371122","莒县","180"],
["1831","371302","兰山区","182"],
["1835","371322","郯城县","182"],
["1839","371326","平邑县","182"],
["1842","371329","临沭县","182"],
["1847","371423","庆云县","183"],
["1850","371426","平原县","183"],
["1854","371482","禹城市","183"],
["1859","371523","茌平县","184"],
["1863","371581","临清市","184"],
["2007","411324","镇平县","199"],
["2010","411327","社旗县","199"],
["2013","411330","桐柏县","199"],
["2018","411421","民权县","200"],
["2021","411424","柘城县","200"],
["2024","411481","永城市","200"],
["2029","411522","光山县","201"],
["2033","411526","潢川县","201"],
["2039","411622","西华县","202"],
["2042","411625","郸城县","202"],
["2045","411628","鹿邑县","202"],
["2050","411722","上蔡县","203"],
["2054","411726","泌阳县","203"],
["2059","420102","江岸区","204"],
["2063","420106","武昌区","204"],
["2068","420114","蔡甸区","204"],
["2071","420117","新洲区","204"],
["2077","420222","阳新县","205"],
["2081","420303","张湾区","206"],
["2085","420324","竹溪县","206"],
["2089","420502","西陵区","207"],
["2094","420525","远安县","207"],
["2097","420528","长阳土家族自治县","207"],
["2100","420582","当阳市","207"],
["2232","430681","汨罗市","223"],
["2237","430721","安乡县","224"],
["2242","430726","石门县","224"],
["2248","430822","桑植县","225"],
["2254","430923","安化县","226"],
["2259","431021","桂阳县","227"],
["2262","431024","嘉禾县","227"],
["2265","431027","桂东县","227"],
["2270","431103","冷水滩区","228"],
["2273","431123","双牌县","228"],
["2277","431127","蓝山县","228"],
["2279","431129","江华瑶族自治县","228"],
["2285","431224","溆浦县","229"],
["2287","431226","麻阳苗族自治县","229"],
["2289","431228","芷江侗族自治县","229"],
["2292","431281","洪江市","229"],
["2297","431381","冷水江市","230"],
["2300","433122","泸溪县","231"],
["2303","433125","保靖县","231"],
["2306","433130","龙山县","231"],
["2312","440106","天河区","232"],
["2317","440114","花都区","232"],
["2321","440203","武江区","233"],
["2326","440229","翁源县","233"],
["2328","440233","新丰县","233"],
["2332","440303","罗湖区","234"],
["2443","445321","新兴县","252"],
["2448","450102","兴宁区","253"],
["2457","450125","上林县","253"],
["2462","450203","鱼峰区","254"],
["2467","450223","鹿寨县","254"],
["2470","450226","三江侗族自治县","254"],
["2478","450322","临桂县","255"],
["2482","450326","永福县","255"],
["2488","450332","恭城瑶族自治县","255"],
["2496","450481","岑溪市","256"],
["2500","450512","铁山港区","257"],
["1829","371203","钢城区","181"],
["1830","371301","市辖区","182"],
["1832","371311","罗庄区","182"],
["1833","371301","河东区","182"],
["1834","371321","沂南县","182"],
["1836","371323","沂水县","182"],
["1837","371324","苍山县","182"],
["1838","371325","费县","182"],
["1840","371327","莒南县","182"],
["1841","371328","蒙阴县","182"],
["1843","371401","市辖区","183"],
["1844","371402","德城区","183"],
["1845","371421","陵县","183"],
["1846","371422","宁津县","183"],
["1848","371424","临邑县","183"],
["1849","371425","齐河县","183"],
["1851","371427","夏津县","183"],
["1852","371428","武城县","183"],
["1853","371481","乐陵市","183"],
["1855","371501","市辖区","184"],
["1856","371502","东昌府区","184"],
["1858","371522","莘县","184"],
["1860","371524","东阿县","184"],
["1861","371525","冠县","184"],
["1864","371601","市辖区","185"],
["1865","371602","滨城区","185"],
["1867","371622","阳信县","185"],
["1868","371623","无棣县","185"],
["1869","371624","沾化县","185"],
["1871","371626","邹平县","185"],
["1873","371702","牡丹区","186"],
["1874","371721","曹县","186"],
["1876","371723","成武县","186"],
["1877","371724","巨野县","186"],
["1879","371726","鄄城县","186"],
["1880","371727","定陶县","186"],
["1881","371728","东明县","186"],
["1883","410102","中原区","187"],
["1884","410103","二七区","187"],
["1886","410105","金水区","187"],
["1887","410106","上街区","187"],
["1888","410108","惠济区","187"],
["1889","410122","中牟县","187"],
["1890","410181","巩义市","187"],
["1892","410183","新密市","187"],
["1893","410184","新郑市","187"],
["1894","410185","登封市","187"],
["1896","410202","龙亭区","188"],
["1897","410203","顺河回族区","188"],
["1899","410205","禹王台区","188"],
["1900","410211","金明区","188"],
["1901","410221","杞县","188"],
["1902","410222","通许县","188"],
["1904","410224","开封县","188"],
["1905","410225","兰考县","188"],
["1906","410301","市辖区","189"],
["1908","410303","西工区","189"],
["1909","410304","瀍河回族区","189"],
["1911","410306","吉利区","189"],
["1912","410311","洛龙区","189"],
["1913","410322","孟津县","189"],
["1915","410324","栾川县","189"],
["1916","410325","嵩县","189"],
["1917","410326","汝阳县","189"],
["1918","410327","宜阳县","189"],
["1920","410329","伊川县","189"],
["1921","410381","偃师市","189"],
["1922","410401","市辖区","190"],
["1924","410403","卫东区","190"],
["1925","410404","石龙区","190"],
["1926","410411","湛河区","190"],
["1928","410422","叶县","190"],
["1929","410423","鲁山县","190"],
["1932","410482","汝州市","190"],
["1933","410501","市辖区","191"],
["1934","410502","文峰区","191"],
["1936","410505","殷都区","191"],
["1937","410506","龙安区","191"],
["1938","410522","安阳县","191"],
["1940","410526","滑县","191"],
["1941","410527","内黄县","191"],
["1942","410581","林州市","191"],
["1943","410601","市辖区","192"],
["1945","410603","山城区","192"],
["1946","410611","淇滨区","192"],
["1947","410621","浚县","192"],
["1948","410622","淇县","192"],
["1950","410702","红旗区","193"],
["1951","410703","卫滨区","193"],
["1952","410704","凤泉区","193"],
["1954","410721","新乡县","193"],
["1955","410724","获嘉县","193"],
["1956","410725","原阳县","193"],
["1958","410727","封丘县","193"],
["1959","410728","长垣县","193"],
["1960","410781","卫辉市","193"],
["1962","410801","市辖区","194"],
["1963","410802","解放区","194"],
["1964","410803","中站区","194"],
["1966","410811","山阳区","194"],
["1967","410821","修武县","194"],
["1968","410822","博爱县","194"],
["1970","410825","温县","194"],
["1971","419001","济源市","194"],
["1972","410882","沁阳市","194"],
["1974","410901","市辖区","195"],
["1975","410902","华龙区","195"],
["1976","410922","清丰县","195"],
["1977","410923","南乐县","195"],
["1978","410926","范县","195"],
["1979","410927","台前县","195"],
["1980","410928","濮阳县","195"],
["1981","411001","市辖区","196"],
["1982","411002","魏都区","196"],
["1983","411023","许昌县","196"],
["1984","411024","鄢陵县","196"],
["1985","411025","襄城县","196"],
["1986","411081","禹州市","196"],
["1987","411082","长葛市","196"],
["1988","411101","市辖区","197"],
["1989","411102","源汇区","197"],
["1990","411103","郾城区","197"],
["1991","411104","召陵区","197"],
["1992","411121","舞阳县","197"],
["1993","411122","临颍县","197"],
["1994","411201","市辖区","198"],
["1995","411202","湖滨区","198"],
["1996","411221","渑池县","198"],
["1997","411222","陕县","198"],
["1998","411224","卢氏县","198"],
["1999","411281","义马市","198"],
["2000","411282","灵宝市","198"],
["2001","411301","市辖区","199"],
["2002","411302","宛城区","199"],
["2003","411303","卧龙区","199"],
["2004","411321","南召县","199"],
["2005","411322","方城县","199"],
["2006","411323","西峡县","199"],
["2008","411325","内乡县","199"],
["2009","411326","淅川县","199"],
["2011","411328","唐河县","199"],
["2012","411329","新野县","199"],
["2014","411381","邓州市","199"],
["2015","411401","市辖区","200"],
["2016","411402","梁园区","200"],
["2017","411403","睢阳区","200"],
["2019","411422","睢县","200"],
["2020","411423","宁陵县","200"],
["2022","411425","虞城县","200"],
["2023","411426","夏邑县","200"],
["2025","411501","市辖区","201"],
["2026","411502","浉河区","201"],
["2027","411503","平桥区","201"],
["2028","411521","罗山县","201"],
["2030","411523","新县","201"],
["2031","411524","商城县","201"],
["2032","411525","固始县","201"],
["2034","411527","淮滨县","201"],
["2035","411528","息县","201"],
["2036","411601","市辖区","202"],
["2037","411602","川汇区","202"],
["2038","411621","扶沟县","202"],
["2040","411623","商水县","202"],
["2041","411624","沈丘县","202"],
["2043","411626","淮阳县","202"],
["2044","411627","太康县","202"],
["2046","411681","项城市","202"],
["2047","411701","市辖区","203"],
["2048","411702","驿城区","203"],
["2049","411721","西平县","203"],
["2051","411723","平舆县","203"],
["2052","411724","正阳县","203"],
["2053","411725","确山县","203"],
["2055","411727","汝南县","203"],
["2056","411728","遂平县","203"],
["2057","411729","新蔡县","203"],
["2058","420101","市辖区","204"],
["2060","420103","江汉区","204"],
["2061","420104","硚口区","204"],
["2062","420105","汉阳区","204"],
["2064","420107","青山区","204"],
["2065","420111","洪山区","204"],
["2066","420112","东西湖区","204"],
["2067","420113","汉南区","204"],
["2069","420115","江夏区","204"],
["2070","420116","黄陂区","204"],
["2072","420201","市辖区","205"],
["2073","420202","黄石港区","205"],
["2074","420203","西塞山区","205"],
["2075","420204","下陆区","205"],
["2076","420205","铁山区","205"],
["2078","420281","大冶市","205"],
["2079","420301","市辖区","206"],
["2080","420302","茅箭区","206"],
["2082","420321","郧县","206"],
["2083","420322","郧西县","206"],
["2084","420323","竹山县","206"],
["2086","420325","房县","206"],
["2087","420381","丹江口市","206"],
["2088","420501","市辖区","207"],
["2090","420503","伍家岗区","207"],
["2091","420504","点军区","207"],
["2092","420505","猇亭区","207"],
["2093","420506","夷陵区","207"],
["2095","420526","兴山县","207"],
["2096","420527","秭归县","207"],
["2098","420529","五峰土家族自治县","207"],
["2099","420581","宜都市","207"],
["2101","420583","枝江市","207"],
["2102","420601","市辖区","208"],
["2103","420602","襄城区","208"],
["2104","420606","樊城区","208"],
["2105","420607","襄阳区","208"],
["2106","420624","南漳县","208"],
["2107","420625","谷城县","208"],
["2108","420626","保康县","208"],
["2109","420682","老河口市","208"],
["2110","420683","枣阳市","208"],
["2111","420684","宜城市","208"],
["2112","420701","市辖区","209"],
["2113","420702","梁子湖区","209"],
["2114","420703","华容区","209"],
["2115","420704","鄂城区","209"],
["2116","420801","市辖区","210"],
["2117","420802","东宝区","210"],
["2118","420804","掇刀区","210"],
["2119","420821","京山县","210"],
["2120","420822","沙洋县","210"],
["2121","420881","钟祥市","210"],
["2122","420901","市辖区","211"],
["2123","420902","孝南区","211"],
["2124","420921","孝昌县","211"],
["2125","420922","大悟县","211"],
["2126","420923","云梦县","211"],
["2127","420981","应城市","211"],
["2128","420982","安陆市","211"],
["2129","420984","汉川市","211"],
["2130","421001","市辖区","212"],
["2131","421002","沙市区","212"],
["2132","421003","荆州区","212"],
["2133","421022","公安县","212"],
["2134","421023","监利县","212"],
["2135","421024","江陵县","212"],
["2137","421083","洪湖市","212"],
["2138","421087","松滋市","212"],
["2139","421101","市辖区","213"],
["2141","421121","团风县","213"],
["2142","421122","红安县","213"],
["2143","421123","罗田县","213"],
["2145","421125","浠水县","213"],
["2146","421126","蕲春县","213"],
["2147","421127","黄梅县","213"],
["2149","421182","武穴市","213"],
["2150","421201","市辖区","214"],
["2151","421202","咸安区","214"],
["2153","421222","通城县","214"],
["2154","421223","崇阳县","214"],
["2155","421224","通山县","214"],
["2157","421301","市辖区","215"],
["2158","421303","曾都区","215"],
["2159","421381","广水市","215"],
["2161","422802","利川市","216"],
["2162","422822","建始县","216"],
["2163","422823","巴东县","216"],
["2165","422826","咸丰县","216"],
["2166","422827","来凤县","216"],
["2167","422828","鹤峰县","216"],
["2169","429005","潜江市","217"],
["2170","429006","天门市","217"],
["2172","430101","市辖区","218"],
["2173","430102","芙蓉区","218"],
["2174","430103","天心区","218"],
["2175","430104","岳麓区","218"],
["2176","430105","开福区","218"],
["2178","430121","长沙县","218"],
["2179","430122","望城县","218"],
["2180","430124","宁乡县","218"],
["2182","430201","市辖区","219"],
["2183","430202","荷塘区","219"],
["2184","430203","芦淞区","219"],
["2186","430211","天元区","219"],
["2187","430221","株洲县","219"],
["2188","430223","攸县","219"],
["2190","430225","炎陵县","219"],
["2191","430281","醴陵市","219"],
["2192","430301","市辖区","220"],
["2194","430304","岳塘区","220"],
["2195","430321","湘潭县","220"],
["2196","430381","湘乡市","220"],
["2198","430401","市辖区","221"],
["2199","430405","珠晖区","221"],
["2200","430406","雁峰区","221"],
["2202","430408","蒸湘区","221"],
["2203","430412","南岳区","221"],
["2204","430421","衡阳县","221"],
["2206","430423","衡山县","221"],
["2207","430424","衡东县","221"],
["2208","430426","祁东县","221"],
["2210","430482","常宁市","221"],
["2211","430501","市辖区","222"],
["2212","430502","双清区","222"],
["2214","430511","北塔区","222"],
["2215","430521","邵东县","222"],
["2216","430522","新邵县","222"],
["2218","430524","隆回县","222"],
["2219","430525","洞口县","222"],
["2220","430527","绥宁县","222"],
["2222","430529","城步苗族自治县","222"],
["2224","430601","市辖区","223"],
["2225","430602","岳阳楼区","223"],
["2226","430603","云溪区","223"],
["2228","430621","岳阳县","223"],
["2229","430623","华容县","223"],
["2230","430624","湘阴县","223"],
["2233","430682","临湘市","223"],
["2234","430701","市辖区","224"],
["2236","430703","鼎城区","224"],
["2238","430722","汉寿县","224"],
["2240","430724","临澧县","224"],
["2241","430725","桃源县","224"],
["2244","430801","市辖区","225"],
["2245","430802","永定区","225"],
["2247","430821","慈利县","225"],
["2249","430901","市辖区","226"],
["2250","430902","资阳区","226"],
["2252","430921","南县","226"],
["2253","430922","桃江县","226"],
["2255","430981","沅江市","226"],
["2256","431001","市辖区","227"],
["2257","431002","北湖区","227"],
["2258","431003","苏仙区","227"],
["2260","431022","宜章县","227"],
["2261","431023","永兴县","227"],
["2263","431025","临武县","227"],
["2264","431026","汝城县","227"],
["2266","431028","安仁县","227"],
["2267","431081","资兴市","227"],
["3350","623027","夏河县","349"],
["3351","630101","市辖区","350"],
["3352","630102","城东区","350"],
["3353","630103","城中区","350"],
["3354","630104","城西区","350"],
["3355","630105","城北区","350"],
["3357","630122","湟中县","350"],
["3358","630123","湟源县","350"],
["3359","632121","平安县","351"],
["3361","632123","乐都县","351"],
["3362","632126","互助土族自治县","351"],
["3364","632128","循化撒拉族自治县","351"],
["3365","632221","门源回族自治县","352"],
["3367","632223","海晏县","352"],
["3368","632224","刚察县","352"],
["3370","632322","尖扎县","353"],
["3371","632323","泽库县","353"],
["3373","632521","共和县","354"],
["3374","632522","同德县","354"],
["3375","632523","贵德县","354"],
["3376","632524","兴海县","354"],
["3378","632621","玛沁县","355"],
["3379","632622","班玛县","355"],
["3380","632623","甘德县","355"],
["3382","632625","久治县","355"],
["3383","632626","玛多县","355"],
["3385","632722","杂多县","356"],
["3386","632723","称多县","356"],
["3387","632724","治多县","356"],
["3389","632726","曲麻莱县","356"],
["3390","632801","格尔木市","357"],
["3392","632821","乌兰县","357"],
["3393","632822","都兰县","357"],
["3394","632823","天峻县","357"],
["3395","640101","市辖区","358"],
["3396","640104","兴庆区","358"],
["3397","640105","西夏区","358"],
["3398","640106","金凤区","358"],
["3400","640122","贺兰县","358"],
["3401","640181","灵武市","358"],
["3402","640201","市辖区","359"],
["3404","640205","惠农区","359"],
["3405","640221","平罗县","359"],
["3406","640301","市辖区","360"],
["3407","640302","利通区","360"],
["3408","640323","盐池县","360"],
["3410","640381","青铜峡市","360"],
["3411","640401","市辖区","361"],
["3412","640402","原州区","361"],
["3413","640422","西吉县","361"],
["3415","640424","泾源县","361"],
["3416","640425","彭阳县","361"],
["3417","640501","市辖区","362"],
["3418","640502","沙坡头区","362"],
["3420","640522","海原县","362"],
["3421","650101","市辖区","363"],
["3422","650102","天山区","363"],
["3423","650103","沙依巴克区","363"],
["3424","650104","新市区","363"],
["3426","650106","头屯河区","363"],
["3427","650107","达坂城区","363"],
["3428","650109","米东区","363"],
["3429","650121","乌鲁木齐县","363"],
["3430","650201","市辖区","364"],
["3432","650203","克拉玛依区","364"],
["3433","650204","白碱滩区","364"],
["3434","650205","乌尔禾区","364"],
["3436","652122","鄯善县","365"],
["3437","652123","托克逊县","365"],
["3441","652301","昌吉市","367"],
["3442","652302","阜康市","367"],
["3445","652324","玛纳斯县","367"],
["3446","652325","奇台县","367"],
["3447","652327","吉木萨尔县","367"],
["3449","652701","博乐市","368"],
["3450","652722","精河县","368"],
["3452","652801","库尔勒市","369"],
["3453","652822","轮台县","369"],
["3455","652824","若羌县","369"],
["492","130529","巨鹿县","41"],
["503","130603","北市区","42"],
["944","211402","连山区","84"],
["945","211403","龙港区","84"],
["946","211404","南票区","84"],
["947","211421","绥中县","84"],
["948","211422","建昌县","84"],
["949","211481","兴城市","84"],
["950","220101","市辖区","85"],
["951","220102","南关区","85"],
["952","220103","宽城区","85"],
["953","220104","朝阳区","85"],
["954","220105","二道区","85"],
["955","220106","绿园区","85"],
["956","220112","双阳区","85"],
["957","220122","农安县","85"],
["958","220181","九台市","85"],
["959","220182","榆树市","85"],
["960","220183","德惠市","85"],
["961","220201","市辖区","86"],
["962","220202","昌邑区","86"],
["963","220203","龙潭区","86"],
["964","220204","船营区","86"],
["965","220211","丰满区","86"],
["966","220221","永吉县","86"],
["967","220281","蛟河市","86"],
["968","220282","桦甸市","86"],
["969","220283","舒兰市","86"],
["970","220284","磐石市","86"],
["971","220301","市辖区","87"],
["972","220302","铁西区","87"],
["973","220303","铁东区","87"],
["974","220322","梨树县","87"],
["975","220323","伊通满族自治县","87"],
["976","220381","公主岭市","87"],
["977","220382","双辽市","87"],
["978","220401","市辖区","88"],
["979","220402","龙山区","88"],
["980","220403","西安区","88"],
["981","220421","东丰县","88"],
["982","220422","东辽县","88"],
["983","220501","市辖区","89"],
["984","220502","东昌区","89"],
["985","220503","二道江区","89"],
["986","220521","通化县","89"],
["987","220523","辉南县","89"],
["988","220524","柳河县","89"],
["990","220582","集安市","89"],
["991","220601","市辖区","90"],
["992","220602","八道江区","90"],
["993","220621","抚松县","90"],
["994","220622","靖宇县","90"],
["996","220605","江源区","90"],
["997","220681","临江市","90"],
["998","220701","市辖区","91"],
["999","220702","宁江区","91"],
["1001","220722","长岭县","91"],
["1002","220723","乾安县","91"],
["1003","220724","扶余县","91"],
["1004","220801","市辖区","92"],
["1005","220802","洮北区","92"],
["1006","220821","镇赉县","92"],
["1008","220881","洮南市","92"],
["1009","220882","大安市","92"],
["1010","222401","延吉市","93"],
["1012","222403","敦化市","93"],
["1013","222404","珲春市","93"],
["1014","222405","龙井市","93"],
["1016","222424","汪清县","93"],
["1017","222426","安图县","93"],
["1018","230101","市辖区","94"],
["1020","230103","南岗区","94"],
["1021","230104","道外区","94"],
["1022","230110","香坊区","94"],
["1024","230108","平房区","94"],
["1025","230109","松北区","94"],
["1027","230123","依兰县","94"],
["1028","230124","方正县","94"],
["1029","230125","宾县","94"],
["1030","230126","巴彦县","94"],
["1032","230128","通河县","94"],
["1033","230129","延寿县","94"],
["1035","230182","双城市","94"],
["1036","230183","尚志市","94"],
["1037","230184","五常市","94"],
["1039","230202","龙沙区","95"],
["1040","230203","建华区","95"],
["2268","431101","市辖区","228"],
["2271","431121","祁阳县","228"],
["2272","431122","东安县","228"],
["2274","431124","道县","228"],
["2275","431125","江永县","228"],
["2276","431126","宁远县","228"],
["2278","431128","新田县","228"],
["2280","431201","市辖区","229"],
["2281","431202","鹤城区","229"],
["2282","431221","中方县","229"],
["2283","431222","沅陵县","229"],
["2284","431223","辰溪县","229"],
["2286","431225","会同县","229"],
["2290","431229","靖州苗族侗族自治县","229"],
["2291","431230","通道侗族自治县","229"],
["2293","431301","市辖区","230"],
["2294","431302","娄星区","230"],
["2295","431321","双峰县","230"],
["2296","431322","新化县","230"],
["2298","431382","涟源市","230"],
["2299","433101","吉首市","231"],
["2301","433123","凤凰县","231"],
["2302","433124","花垣县","231"],
["2304","433126","古丈县","231"],
["2305","433127","永顺县","231"],
["2307","440101","市辖区","232"],
["2308","440115","南沙区","232"],
["2309","440103","荔湾区","232"],
["2310","440104","越秀区","232"],
["2311","440105","海珠区","232"],
["2313","440116","萝岗区","232"],
["2314","440111","白云区","232"],
["2315","440112","黄埔区","232"],
["2316","440113","番禺区","232"],
["2318","440183","增城市","232"],
["2319","440184","从化市","232"],
["2320","440201","市辖区","233"],
["2322","440204","浈江区","233"],
["2323","440205","曲江区","233"],
["2324","440222","始兴县","233"],
["2325","440224","仁化县","233"],
["2327","440232","乳源瑶族自治县","233"],
["2329","440281","乐昌市","233"],
["2330","440282","南雄市","233"],
["2331","440301","市辖区","234"],
["2333","440304","福田区","234"],
["2334","440305","南山区","234"],
["2335","440306","宝安区","234"],
["2337","440308","盐田区","234"],
["2338","440401","市辖区","235"],
["2339","440402","香洲区","235"],
["2340","440403","斗门区","235"],
["2341","440404","金湾区","235"],
["2342","440501","市辖区","236"],
["2343","440507","龙湖区","236"],
["2344","440511","金平区","236"],
["2345","440512","濠江区","236"],
["2346","440513","潮阳区","236"],
["2347","440514","潮南区","236"],
["2348","440515","澄海区","236"],
["2349","440523","南澳县","236"],
["2350","440601","市辖区","237"],
["2351","440604","禅城区","237"],
["2352","440605","南海区","237"],
["2353","440606","顺德区","237"],
["2354","440607","三水区","237"],
["2355","440608","高明区","237"],
["2356","440701","市辖区","238"],
["2357","440703","蓬江区","238"],
["2358","440704","江海区","238"],
["2359","440705","新会区","238"],
["2360","440781","台山市","238"],
["2361","440783","开平市","238"],
["2362","440784","鹤山市","238"],
["2363","440785","恩平市","238"],
["2364","440801","市辖区","239"],
["2365","440802","赤坎区","239"],
["2366","440803","霞山区","239"],
["2367","440804","坡头区","239"],
["2368","440811","麻章区","239"],
["2369","440823","遂溪县","239"],
["2370","440825","徐闻县","239"],
["2371","440881","廉江市","239"],
["2372","440882","雷州市","239"],
["2373","440883","吴川市","239"],
["2374","440901","市辖区","240"],
["2375","440902","茂南区","240"],
["2376","440903","茂港区","240"],
["2377","440923","电白县","240"],
["2378","440981","高州市","240"],
["2379","440982","化州市","240"],
["2380","440983","信宜市","240"],
["2381","441201","市辖区","241"],
["2382","441202","端州区","241"],
["2383","441203","鼎湖区","241"],
["2384","441223","广宁县","241"],
["2385","441224","怀集县","241"],
["2386","441225","封开县","241"],
["2387","441226","德庆县","241"],
["2388","441283","高要市","241"],
["2389","441284","四会市","241"],
["2390","441301","市辖区","242"],
["2391","441302","惠城区","242"],
["2392","441303","惠阳区","242"],
["2393","441322","博罗县","242"],
["2394","441323","惠东县","242"],
["2395","441324","龙门县","242"],
["2396","441401","市辖区","243"],
["2397","441402","梅江区","243"],
["2398","441421","梅县","243"],
["2399","441422","大埔县","243"],
["2400","441423","丰顺县","243"],
["2401","441424","五华县","243"],
["2402","441426","平远县","243"],
["2403","441427","蕉岭县","243"],
["2404","441481","兴宁市","243"],
["2406","441502","城区","244"],
["2407","441521","海丰县","244"],
["2408","441523","陆河县","244"],
["2410","441601","市辖区","245"],
["2411","441602","源城区","245"],
["2412","441621","紫金县","245"],
["2414","441623","连平县","245"],
["2415","441624","和平县","245"],
["2416","441625","东源县","245"],
["2418","441702","江城区","246"],
["2419","441721","阳西县","246"],
["2420","441723","阳东县","246"],
["2422","441801","市辖区","247"],
["2423","441802","清城区","247"],
["2424","441821","佛冈县","247"],
["2428","441827","清新县","247"],
["2429","441881","英德市","247"],
["2430","441882","连州市","247"],
["2431","445101","市辖区","250"],
["2432","445102","湘桥区","250"],
["2434","445122","饶平县","250"],
["2435","445201","市辖区","251"],
["2436","445202","榕城区","251"],
["2438","445222","揭西县","251"],
["2439","445224","惠来县","251"],
["2440","445281","普宁市","251"],
["2442","445302","云城区","252"],
["2444","445322","郁南县","252"],
["2446","445381","罗定市","252"],
["2447","450101","市辖区","253"],
["2450","450105","江南区","253"],
["2451","450107","西乡塘区","253"],
["2453","450109","邕宁区","253"],
["2454","450122","武鸣县","253"],
["2455","450123","隆安县","253"],
["2458","450126","宾阳县","253"],
["2459","450127","横县","253"],
["2460","450201","市辖区","254"],
["2463","450204","柳南区","254"],
["2464","450205","柳北区","254"],
["2466","450222","柳城县","254"],
["2468","450224","融安县","254"],
["2471","450301","市辖区","255"],
["2472","450302","秀峰区","255"],
["2474","450304","象山区","255"],
["2475","450305","七星区","255"],
["2476","450311","雁山区","255"],
["2479","450323","灵川县","255"],
["2480","450324","全州县","255"],
["2483","450327","灌阳县","255"],
["2485","450329","资源县","255"],
["2486","450330","平乐县","255"],
["2487","450331","荔蒲县","255"],
["2490","450403","万秀区","256"],
["2491","450404","蝶山区","256"],
["2492","450405","长洲区","256"],
["2494","450422","藤县","256"],
["2495","450423","蒙山县","256"],
["2498","450502","海城区","257"],
["2499","450503","银海区","257"],
["2502","450601","市辖区","258"],
["2503","450602","港口区","258"],
["2504","450603","防城区","258"],
["2506","450681","东兴市","258"],
["2507","450701","市辖区","259"],
["2510","450721","灵山县","259"],
["2511","450722","浦北县","259"],
["2512","450801","市辖区","260"],
["2515","450804","覃塘区","260"],
["2516","450821","平南县","260"],
["2518","450901","市辖区","261"],
["2519","450902","玉州区","261"],
["2520","450921","容县","261"],
["2523","450924","兴业县","261"],
["2524","450981","北流市","261"],
["2526","451002","右江区","262"],
["2528","451022","田东县","262"],
["2529","451023","平果县","262"],
["2530","451024","德保县","262"],
["2532","451026","那坡县","262"],
["2533","451027","凌云县","262"],
["2535","451029","田林县","262"],
["2536","451030","西林县","262"],
["2538","451101","市辖区","263"],
["2539","451102","八步区","263"],
["2540","451121","昭平县","263"],
["2541","451122","钟山县","263"],
["2543","451201","市辖区","264"],
["2544","451202","金城江区","264"],
["2545","451221","南丹县","264"],
["2546","451222","天峨县","264"],
["2547","451223","凤山县","264"],
["2548","451224","东兰县","264"],
["2550","451226","环江毛南族自治县","264"],
["2552","451228","都安瑶族自治县","264"],
["2553","451229","大化瑶族自治县","264"],
["2555","451301","市辖区","265"],
["2556","451302","兴宾区","265"],
["2557","451321","忻城县","265"],
["2558","451322","象州县","265"],
["2560","451324","金秀瑶族自治县","265"],
["2336","440307","龙岗区","234"],
["2562","451401","市辖区","266"],
["2563","451402","江洲区","266"],
["2564","451421","扶绥县","266"],
["2566","451423","龙州县","266"],
["2567","451424","大新县","266"],
["2568","451425","天等县","266"],
["236","440500","汕头市","20"],
["2569","451481","凭祥市","266"],
["2570","460101","市辖区","267"],
["2571","460105","秀英区","267"],
["2572","460106","龙华区","267"],
["2573","460107","琼山区","267"],
["2574","460108","美兰区","267"],
["2575","460201","市辖区","268"],
["2576","469001","五指山市","269"],
["2577","469002","琼海市","269"],
["2578","469003","儋州市","269"],
["2579","469005","文昌市","269"],
["2580","469006","万宁市","269"],
["2581","469007","东方市","269"],
["2582","469021","定安县","269"],
["2583","469022","屯昌县","269"],
["2584","469023","澄迈县","269"],
["2585","469024","临高县","269"],
["2586","469025","白沙黎族自治县","269"],
["2588","469027","乐东黎族自治县","269"],
["2589","469028","陵水黎族自治县","269"],
["2590","469029","保亭黎族苗族自治县","269"],
["2591","469030","琼中黎族苗族自治县","269"],
["2592","469031","西沙群岛","269"],
["2593","469032","南沙群岛","269"],
["2594","469033","中沙群岛的岛礁及其海域","269"],
["2595","500101","万州区","270"],
["2596","500102","涪陵区","270"],
["2597","500103","渝中区","270"],
["2599","500105","江北区","270"],
["2600","500106","沙坪坝区","270"],
["2601","500107","九龙坡区","270"],
["2602","500108","南岸区","270"],
["2603","500109","北碚区","270"],
["2604","500110","万盛区","270"],
["2605","500111","双桥区","270"],
["2606","500112","渝北区","270"],
["2607","500113","巴南区","270"],
["2608","500114","黔江区","270"],
["2609","500115","长寿区","270"],
["2610","500222","綦江县","271"],
["2611","500223","潼南县","271"],
["2612","500224","铜梁县","271"],
["2613","500225","大足县","271"],
["2614","500226","荣昌县","271"],
["2615","500227","璧山县","271"],
["2616","500228","梁平县","271"],
["2617","500229","城口县","271"],
["2618","500230","丰都县","271"],
["2619","500231","垫江县","271"],
["2620","500232","武隆县","271"],
["2621","500233","忠县","271"],
["2622","500234","开县","271"],
["2623","500235","云阳县","271"],
["2624","500236","奉节县","271"],
["2625","500237","巫山县","271"],
["2626","500238","巫溪县","271"],
["2627","500240","石柱土家族自治县","271"],
["2628","500241","秀山土家族苗族自治县","271"],
["2630","500243","彭水苗族土家族自治县","271"],
["2631","500116","江津区","272"],
["2632","500117","合川区","272"],
["2633","500118","永川区","272"],
["2634","500119","南川区","272"],
["2635","510101","市辖区","273"],
["2636","510104","锦江区","273"],
["2637","510105","青羊区","273"],
["2638","510106","金牛区","273"],
["2639","510107","武侯区","273"],
["2640","510108","成华区","273"],
["2641","510112","龙泉驿区","273"],
["2642","510113","青白江区","273"],
["2643","510114","新都区","273"],
["2644","510115","温江区","273"],
["2646","510122","双流县","273"],
["2647","510124","郫县","273"],
["2649","510131","蒲江县","273"],
["2652","510182","彭州市","273"],
["2653","510183","邛崃市","273"],
["2655","510301","市辖区","274"],
["2657","510303","贡井区","274"],
["2658","510304","大安区","274"],
["2659","510311","沿滩区","274"],
["2660","510321","荣县","274"],
["2662","510401","市辖区","275"],
["2664","510403","西区","275"],
["2665","510411","仁和区","275"],
["2667","510422","盐边县","275"],
["2668","510501","市辖区","276"],
["2671","510504","龙马潭区","276"],
["2672","510521","泸县","276"],
["2673","510522","合江县","276"],
["2676","510601","市辖区","277"],
["2677","510603","旌阳区","277"],
["2679","510626","罗江县","277"],
["2681","510682","什邡市","277"],
["2683","510701","市辖区","278"],
["2684","510703","涪城区","278"],
["2687","510723","盐亭县","278"],
["2688","510724","安县","278"],
["2689","510725","梓潼县","278"],
["2692","510781","江油市","278"],
["2693","510801","市辖区","279"],
["2694","511002","市中区","279"],
["2695","510811","元坝区","279"],
["2698","510822","青川县","279"],
["2699","510823","剑阁县","279"],
["2701","510901","市辖区","280"],
["2702","510903","船山区","280"],
["2703","510904","安居区","280"],
["2706","510923","大英县","280"],
["2707","511001","市辖区","281"],
["2709","511011","东兴区","281"],
["2710","511024","威远县","281"],
["2713","511101","市辖区","282"],
["2714","511102","市中区","282"],
["2715","511111","沙湾区","282"],
["2717","511113","金口河区","282"],
["2719","511124","井研县","282"],
["2721","511129","沐川县","282"],
["2724","511181","峨眉山市","282"],
["2725","511301","市辖区","283"],
["2726","511302","顺庆区","283"],
["2728","511304","嘉陵区","283"],
["2729","511321","南部县","283"],
["2732","511324","仪陇县","283"],
["2733","511325","西充县","283"],
["2736","511402","东坡区","284"],
["2737","511421","仁寿县","284"],
["2738","511422","彭山县","284"],
["2741","511425","青神县","284"],
["2742","511501","市辖区","285"],
["2744","511521","宜宾县","285"],
["2745","511522","南溪县","285"],
["2748","511525","高县","285"],
["2749","511526","珙县","285"],
["2751","511528","兴文县","285"],
["2753","511601","市辖区","286"],
["2754","511602","广安区","286"],
["2755","511621","岳池县","286"],
["2759","511701","市辖区","287"],
["2761","511721","达县","287"],
["2762","511722","宣汉县","287"],
["2765","511725","渠县","287"],
["2766","511781","万源市","287"],
["2767","511801","市辖区","288"],
["2768","511802","雨城区","288"],
["2770","511822","荥经县","288"],
["2772","511824","石棉县","288"],
["2774","511826","芦山县","288"],
["2776","511901","市辖区","289"],
["2778","511921","通江县","289"],
["2779","511922","南江县","289"],
["2782","512002","雁江区","290"],
["2783","512021","安岳县","290"],
["2784","512022","乐至县","290"],
["2786","513221","汶川县","291"],
["2788","513223","茂县","291"],
["2789","513224","松潘县","291"],
["2792","513227","小金县","291"],
["2793","513228","黑水县","291"],
["2796","513231","阿坝县","291"],
["2797","513232","若尔盖县","291"],
["2799","513321","康定县","292"],
["2801","513323","丹巴县","292"],
["2803","513325","雅江县","292"],
["2804","513326","道孚县","292"],
["248","441900","东莞市","20"],
["248001","441901","莞城区","248"],
["248002","441902","东城区","248"],
["248003","441903","南城区","248"],
["248004","441904","万江区","248"],
["248005","441905","石龙镇","248"],
["248006","441906","石排镇","248"],
["248007","441906","茶山镇","248"],
["248008","441906","企石镇","248"],
["248009","441906","桥头镇","248"],
["248010","441906","东坑镇","248"],
["248011","441906","横沥镇","248"],
["248012","441906","常平镇","248"],
["248013","441906","虎门镇","248"],
["248014","441906","长安镇","248"],
["248015","441906","沙田镇","248"],
["248016","441906","厚街镇","248"],
["248017","441906","寮步镇","248"],
["248018","441906","大朗镇","248"],
["248019","441906","黄江镇","248"],
["248020","441906","谢岗镇","248"],
["248021","441906","塘厦镇","248"],
["248022","441906","清溪镇","248"],
["248023","441906","凤岗镇","248"],
["248024","441906","麻涌镇","248"],
["248025","441906","中堂镇","248"],
["248026","441906","高埗镇","248"],
["248027","441906","石碣镇","248"],
["248028","441906","洪梅镇","248"],
["248029","441906","道滘镇","248"],
["248030","441906","大岭山镇","248"],
["248031","441906","樟木头镇","248"],
["248032","441906","望牛墩镇","248"],
["2805","513327","炉霍县","292"],
["2806","513328","甘孜县","292"],
["2807","513329","新龙县","292"],
["2808","513330","德格县","292"],
["2809","513331","白玉县","292"],
["2810","513332","石渠县","292"],
["2811","513333","色达县","292"],
["2812","513334","理塘县","292"],
["2813","513335","巴塘县","292"],
["2814","513336","乡城县","292"],
["2815","513337","稻城县","292"],
["2816","513338","得荣县","292"],
["2817","513401","西昌市","293"],
["2818","513422","木里藏族自治县","293"],
["2819","513423","盐源县","293"],
["2820","513424","德昌县","293"],
["2821","513425","会理县","293"],
["2822","513426","会东县","293"],
["2823","513427","宁南县","293"],
["2824","513428","普格县","293"],
["2825","513429","布拖县","293"],
["2826","513430","金阳县","293"],
["2827","513431","昭觉县","293"],
["2828","513432","喜德县","293"],
["2829","513433","冕宁县","293"],
["2830","513434","越西县","293"],
["2831","513435","甘洛县","293"],
["2832","513436","美姑县","293"],
["2833","513437","雷波县","293"],
["2834","520101","市辖区","294"],
["2835","520102","南明区","294"],
["2836","520103","云岩区","294"],
["2837","520111","花溪区","294"],
["2838","520112","乌当区","294"],
["2839","520113","白云区","294"],
["2840","520114","小河区","294"],
["2841","520121","开阳县","294"],
["2842","520122","息烽县","294"],
["2843","520123","修文县","294"],
["2844","520181","清镇市","294"],
["2845","520201","钟山区","295"],
["2846","520203","六枝特区","295"],
["2847","520221","水城县","295"],
["2848","520222","盘县","295"],
["2849","520301","市辖区","296"],
["2850","520302","红花岗区","296"],
["2851","520303","汇川区","296"],
["2852","520321","遵义县","296"],
["2853","520322","桐梓县","296"],
["2854","520323","绥阳县","296"],
["2855","520324","正安县","296"],
["2856","520325","道真仡佬族苗族自治县","296"],
["2857","520326","务川仡佬族苗族自治县","296"],
["2858","520327","凤冈县","296"],
["2859","520328","湄潭县","296"],
["2860","520329","余庆县","296"],
["2861","520330","习水县","296"],
["2862","520381","赤水市","296"],
["2863","520382","仁怀市","296"],
["2864","520401","市辖区","297"],
["2865","520402","西秀区","297"],
["2866","520421","平坝县","297"],
["2867","520422","普定县","297"],
["2869","520424","关岭布依族苗族自治县","297"],
["2870","520425","紫云苗族布依族自治县","297"],
["2871","522201","铜仁市","298"],
["2872","522222","江口县","298"],
["2873","522223","玉屏侗族自治县","298"],
["2874","522224","石阡县","298"],
["2875","522225","思南县","298"],
["2876","522226","印江土家族苗族自治县","298"],
["2877","522227","德江县","298"],
["2878","522228","沿河土家族自治县","298"],
["2880","522230","万山特区","298"],
["2881","522301","兴义市","299"],
["2882","522322","兴仁县","299"],
["2884","522324","晴隆县","299"],
["2885","522325","贞丰县","299"],
["2887","522327","册亨县","299"],
["2888","522328","安龙县","299"],
["2890","522422","大方县","300"],
["2891","522423","黔西县","300"],
["2893","522425","织金县","300"],
["2894","522426","纳雍县","300"],
["2896","522428","赫章县","300"],
["2897","522601","凯里市","301"],
["2898","522622","黄平县","301"],
["2899","522623","施秉县","301"],
["2901","522625","镇远县","301"],
["2902","522626","岑巩县","301"],
["2904","522628","锦屏县","301"],
["2905","522629","剑河县","301"],
["2907","522631","黎平县","301"],
["2908","522632","榕江县","301"],
["2910","522634","雷山县","301"],
["2911","522635","麻江县","301"],
["2912","522636","丹寨县","301"],
["2914","522702","福泉市","302"],
["2915","522722","荔波县","302"],
["2917","522725","瓮安县","302"],
["2918","522726","独山县","302"],
["2919","522727","平塘县","302"],
["2921","522729","长顺县","302"],
["2922","522730","龙里县","302"],
["2924","522732","三都水族自治县","302"],
["2925","530101","市辖区","303"],
["2927","530103","盘龙区","303"],
["2928","530111","官渡区","303"],
["2929","530112","西山区","303"],
["2931","530121","呈贡县","303"],
["2932","530122","晋宁县","303"],
["2936","530127","嵩明县","303"],
["2939","530181","安宁市","303"],
["2940","530301","市辖区","304"],
["2941","530302","麒麟区","304"],
["2942","530321","马龙县","304"],
["2943","530322","陆良县","304"],
["2944","530323","师宗县","304"],
["2946","530325","富源县","304"],
["2948","530328","沾益县","304"],
["2950","530401","市辖区","305"],
["2952","530421","江川县","305"],
["2953","530422","澄江县","305"],
["2956","530425","易门县","305"],
["2960","530501","市辖区","306"],
["2961","530502","隆阳区","306"],
["2962","530521","施甸县","306"],
["2963","530522","腾冲县","306"],
["2964","530523","龙陵县","306"],
["2965","530524","昌宁县","306"],
["2966","530601","市辖区","307"],
["2967","530602","昭阳区","307"],
["2970","530623","盐津县","307"],
["2971","530624","大关县","307"],
["2974","530627","镇雄县","307"],
["2975","530628","彝良县","307"],
["2978","530701","市辖区","308"],
["2979","530702","古城区","308"],
["2981","530722","永胜县","308"],
["2982","530723","华坪县","308"],
["2984","530801","市辖区","309"],
["2985","530802","思茅区","309"],
["2987","530822","墨江哈尼族自治县","309"],
["2994","530829","西盟佤族自治县","309"],
["2995","530901","市辖区","310"],
["2996","530902","临翔区","310"],
["2997","530921","凤庆县","310"],
["2998","530922","云县","310"],
["3000","530924","镇康县","310"],
["3003","530927","沧源佤族自治县","310"],
["3004","532301","楚雄市","311"],
["3006","532323","牟定县","311"],
["3007","532324","南华县","311"],
["3009","532326","大姚县","311"],
["3011","532328","元谋县","311"],
["3013","532331","禄丰县","311"],
["3015","532502","开远市","312"],
["431","130132","元氏县","37"],
["451","130281","遵化市","38"],
["457","130321","青龙满族自治县","39"],
["3018","532524","建水县","312"],
["3020","532526","弥勒县","312"],
["3021","532527","泸西县","312"],
["3022","532528","元阳县","312"],
["3027","532621","文山县","313"],
["3028","532622","砚山县","313"],
["3029","532623","西畴县","313"],
["3030","532624","麻栗坡县","313"],
["3031","532625","马关县","313"],
["3032","532626","丘北县","313"],
["3034","532628","富宁县","313"],
["3035","532801","景洪市","314"],
["3036","532822","勐海县","314"],
["3038","532901","大理市","315"],
["3040","532923","祥云县","315"],
["3041","532924","宾川县","315"],
["3042","532925","弥渡县","315"],
["3025","532531","绿春县","312"],
["3043","532926","南涧彝族自治县","315"],
["3045","532928","永平县","315"],
["3046","532929","云龙县","315"],
["3047","532930","洱源县","315"],
["3048","532931","剑川县","315"],
["3049","532932","鹤庆县","315"],
["3051","533103","芒市","316"],
["3052","533122","梁河县","316"],
["3053","533123","盈江县","316"],
["3055","533321","泸水县","317"],
["3056","533323","福贡县","317"],
["3058","533325","兰坪白族普米族自治县","317"],
["3059","533421","香格里拉县","318"],
["3060","533422","德钦县","318"],
["3061","533423","维西傈僳族自治县","318"],
["3062","540101","市辖区","319"],
["3063","540102","城关区","319"],
["3064","540121","林周县","319"],
["3065","540122","当雄县","319"],
["3066","540123","尼木县","319"],
["3067","540124","曲水县","319"],
["3068","540125","堆龙德庆县","319"],
["3069","540126","达孜县","319"],
["3070","540127","墨竹工卡县","319"],
["3071","542121","昌都县","320"],
["3072","542122","江达县","320"],
["3073","542123","贡觉县","320"],
["3074","542124","类乌齐县","320"],
["3075","542125","丁青县","320"],
["3076","542126","察雅县","320"],
["3077","542127","八宿县","320"],
["3078","542128","左贡县","320"],
["3079","542129","芒康县","320"],
["3080","542132","洛隆县","320"],
["3081","542133","边坝县","320"],
["3082","542221","乃东县","321"],
["3083","542222","扎囊县","321"],
["3084","542223","贡嘎县","321"],
["3085","542224","桑日县","321"],
["3086","542225","琼结县","321"],
["3087","542226","曲松县","321"],
["3088","542227","措美县","321"],
["3089","542228","洛扎县","321"],
["3090","542229","加查县","321"],
["3091","542231","隆子县","321"],
["3092","542232","错那县","321"],
["3093","542233","浪卡子县","321"],
["3094","542301","日喀则市","322"],
["3095","542322","南木林县","322"],
["3096","542323","江孜县","322"],
["3097","542324","定日县","322"],
["3098","542325","萨迦县","322"],
["3099","542326","拉孜县","322"],
["3100","542327","昂仁县","322"],
["3101","542328","谢通门县","322"],
["3102","542329","白朗县","322"],
["3104","542331","康马县","322"],
["3105","542332","定结县","322"],
["3107","542334","亚东县","322"],
["3109","542336","聂拉木县","322"],
["3110","542337","萨嘎县","322"],
["3111","542338","岗巴县","322"],
["3113","542422","嘉黎县","323"],
["3114","542423","比如县","323"],
["3115","542424","聂荣县","323"],
["3117","542426","申扎县","323"],
["3118","542427","索县","323"],
["3120","542429","巴青县","323"],
["3121","542430","尼玛县","323"],
["3122","542521","普兰县","324"],
["3124","542523","噶尔县","324"],
["3125","542524","日土县","324"],
["3126","542525","革吉县","324"],
["3128","542527","措勤县","324"],
["3129","542621","林芝县","325"],
["3131","542623","米林县","325"],
["3132","542624","墨脱县","325"],
["3134","542626","察隅县","325"],
["3135","542627","朗县","325"],
["3136","610101","市辖区","326"],
["3137","610102","新城区","326"],
["3138","610103","碑林区","326"],
["3139","610104","莲湖区","326"],
["3141","610112","未央区","326"],
["3142","610113","雁塔区","326"],
["3143","610114","阎良区","326"],
["3145","610116","长安区","326"],
["3146","610122","蓝田县","326"],
["3147","610124","周至县","326"],
["3149","610126","高陵县","326"],
["3150","610201","市辖区","327"],
["3151","610202","王益区","327"],
["3152","610203","印台区","327"],
["3153","610204","耀州区","327"],
["3154","610222","宜君县","327"],
["3155","610301","市辖区","328"],
["3157","610303","金台区","328"],
["3158","610304","陈仓区","328"],
["3159","610322","凤翔县","328"],
["3161","610324","扶风县","328"],
["3162","610326","眉县","328"],
["3163","610327","陇县","328"],
["3165","610329","麟游县","328"],
["3166","610330","凤县","328"],
["3167","610331","太白县","328"],
["3168","610401","市辖区","329"],
["3170","610403","杨陵区","329"],
["3171","610404","渭城区","329"],
["3172","610422","三原县","329"],
["3174","610424","乾县","329"],
["3175","610425","礼泉县","329"],
["3177","610427","彬县","329"],
["3178","610428","长武县","329"],
["3179","610429","旬邑县","329"],
["3181","610431","武功县","329"],
["3182","610481","兴平市","329"],
["3183","610501","市辖区","330"],
["3184","610502","临渭区","330"],
["3186","610522","潼关县","330"],
["3187","610523","大荔县","330"],
["3189","610525","澄城县","330"],
["3190","610526","蒲城县","330"],
["3192","610528","富平县","330"],
["3193","610581","韩城市","330"],
["3195","610601","市辖区","331"],
["3196","610602","宝塔区","331"],
["3197","610621","延长县","331"],
["3198","610622","延川县","331"],
["3200","610624","安塞县","331"],
["3201","610625","志丹县","331"],
["3203","610627","甘泉县","331"],
["3204","610628","富县","331"],
["3205","610629","洛川县","331"],
["3207","610631","黄龙县","331"],
["3209","610701","市辖区","332"],
["3210","610702","汉台区","332"],
["3211","610721","南郑县","332"],
["3212","610722","城固县","332"],
["3214","610724","西乡县","332"],
["3215","610725","勉县","332"],
["3217","610727","略阳县","332"],
["3218","610728","镇巴县","332"],
["3219","610729","留坝县","332"],
["3221","610801","市辖区","333"],
["3223","610821","神木县","333"],
["3224","610822","府谷县","333"],
["3227","610825","定边县","333"],
["3228","610826","绥德县","333"],
["3229","610827","米脂县","333"],
["3232","610830","清涧县","333"],
["3233","610831","子洲县","333"],
["3235","610902","汉滨区","334"],
["480","130481","武安市","40"],
["3236","610921","汉阴县","334"],
["3237","610922","石泉县","334"],
["3239","610924","紫阳县","334"],
["3240","610925","岚皋县","334"],
["3241","610926","平利县","334"],
["3243","610928","旬阳县","334"],
["3244","610929","白河县","334"],
["3245","611001","市辖区","335"],
["3247","611021","洛南县","335"],
["3248","611022","丹凤县","335"],
["3249","611023","商南县","335"],
["3251","611025","镇安县","335"],
["3252","611026","柞水县","335"],
["3253","620101","市辖区","336"],
["3255","620103","七里河区","336"],
["3256","620104","西固区","336"],
["3258","620111","红古区","336"],
["3259","620121","永登县","336"],
["3260","620122","皋兰县","336"],
["3262","620201","市辖区","337"],
["3263","620301","市辖区","338"],
["3264","620302","金川区","338"],
["3266","620401","市辖区","339"],
["3267","620402","白银区","339"],
["3268","620403","平川区","339"],
["3270","620422","会宁县","339"],
["3271","620423","景泰县","339"],
["3272","620501","市辖区","340"],
["3274","620502","秦州区","340"],
["3275","620521","清水县","340"],
["3276","620522","秦安县","340"],
["3278","620524","武山县","340"],
["3280","620601","市辖区","341"],
["3281","620602","凉州区","341"],
["3282","620621","民勤县","341"],
["3283","620622","古浪县","341"],
["3284","620623","天祝藏族自治县","341"],
["3285","620701","市辖区","342"],
["3287","620721","肃南裕固族自治县","342"],
["3289","620723","临泽县","342"],
["3290","620724","高台县","342"],
["3291","620725","山丹县","342"],
["3293","620802","崆峒区","343"],
["3294","620821","泾川县","343"],
["3295","620822","灵台县","343"],
["3297","620824","华亭县","343"],
["3298","620825","庄浪县","343"],
["3299","620826","静宁县","343"],
["3301","620902","肃州区","344"],
["3302","620921","金塔县","344"],
["3306","620981","玉门市","344"],
["3307","620982","敦煌市","344"],
["3308","621001","市辖区","345"],
["3309","621002","西峰区","345"],
["3310","621021","庆城县","345"],
["3311","621022","环县","345"],
["3312","621023","华池县","345"],
["3314","621025","正宁县","345"],
["3315","621026","宁县","345"],
["3316","621027","镇原县","345"],
["3318","621102","安定区","346"],
["3319","621121","通渭县","346"],
["3320","621122","陇西县","346"],
["3322","621124","临洮县","346"],
["3323","621125","漳县","346"],
["3324","621126","岷县","346"],
["3325","621201","市辖区","347"],
["3327","621221","成县","347"],
["3328","621222","文县","347"],
["3329","621223","宕昌县","347"],
["3330","621224","康县","347"],
["3332","621226","礼县","347"],
["3333","621227","徽县","347"],
["3334","621228","两当县","347"],
["3335","622901","临夏市","348"],
["3336","622921","临夏县","348"],
["3337","622922","康乐县","348"],
["3338","622923","永靖县","348"],
["3339","622924","广河县","348"],
["3340","622925","和政县","348"],
["3341","622926","东乡族自治县","348"],
["3342","622927","积石山保安族东乡族撒拉族自治县","348"],
["3343","623001","合作市","349"],
["3344","623021","临潭县","349"],
["3345","623022","卓尼县","349"],
["3346","623023","舟曲县","349"],
["3347","623024","迭部县","349"],
["3348","623025","玛曲县","349"],
["3349","623026","碌曲县","349"],
["506","130622","清苑县","42"],
["508","130624","阜平县","42"],
["509","130625","徐水县","42"],
["510","130626","定兴县","42"],
["512","130628","高阳县","42"],
["513","130629","容城县","42"],
["515","130631","望都县","42"],
["516","130632","安新县","42"],
["517","130633","易县","42"],
["519","130635","蠡县","42"],
["520","130636","顺平县","42"],
["521","130637","博野县","42"],
["522","130638","雄县","42"],
["524","130682","定州市","42"],
["525","130683","安国市","42"],
["527","130701","市辖区","43"],
["528","130702","桥东区","43"],
["529","130703","桥西区","43"],
["530","130705","宣化区","43"],
["532","130721","宣化县","43"],
["533","130722","张北县","43"],
["534","130723","康保县","43"],
["536","130725","尚义县","43"],
["537","130726","蔚县","43"],
["538","130727","阳原县","43"],
["540","130729","万全县","43"],
["541","130730","怀来县","43"],
["542","130731","涿鹿县","43"],
["544","130733","崇礼县","43"],
["545","130801","市辖区","44"],
["546","130802","双桥区","44"],
["548","130804","鹰手营子矿区","44"],
["550","130822","兴隆县","44"],
["551","130823","平泉县","44"],
["552","130824","滦平县","44"],
["554","130826","丰宁满族自治县","44"],
["556","130828","围场满族蒙古族自治县","44"],
["557","130901","市辖区","45"],
["559","130903","运河区","45"],
["560","130921","沧县","45"],
["561","130922","青县","45"],
["562","130923","东光县","45"],
["564","130925","盐山县","45"],
["565","130926","肃宁县","45"],
["567","130928","吴桥县","45"],
["568","130929","献县","45"],
["570","130981","泊头市","45"],
["571","130982","任丘市","45"],
["572","130983","黄骅市","45"],
["573","130984","河间市","45"],
["574","131001","市辖区","46"],
["575","131002","安次区","46"],
["576","131003","广阳区","46"],
["577","131022","固安县","46"],
["578","131023","永清县","46"],
["579","131024","香河县","46"],
["580","131025","大城县","46"],
["581","131026","文安县","46"],
["582","131028","大厂回族自治县","46"],
["583","131081","霸州市","46"],
["584","131082","三河市","46"],
["585","131101","市辖区","47"],
["586","131102","桃城区","47"],
["588","131122","武邑县","47"],
["589","131123","武强县","47"],
["590","131124","饶阳县","47"],
["592","131126","故城县","47"],
["593","131127","景县","47"],
["595","131181","冀州市","47"],
["596","131182","深州市","47"],
["597","140101","市辖区","48"],
["599","140106","迎泽区","48"],
["600","140107","杏花岭区","48"],
["603","140110","晋源区","48"],
["604","140121","清徐县","48"],
["606","140123","娄烦县","48"],
["607","140181","古交市","48"],
["608","140201","市辖区","49"],
["609","140202","城区","49"],
["610","140203","矿区","49"],
["612","140212","新荣区","49"],
["613","140221","阳高县","49"],
["615","140223","广灵县","49"],
["616","140224","灵丘县","49"],
["618","140226","左云县","49"],
["619","140227","大同县","49"],
["620","140301","市辖区","50"],
["621","140302","城区","50"],
["622","140303","矿区","50"],
["623","140311","郊区","50"],
["625","140322","盂县","50"],
["626","140401","市辖区","51"],
["627","140402","城区","51"],
["628","140411","郊区","51"],
["629","140421","长治县","51"],
["630","140423","襄垣县","51"],
["632","140425","平顺县","51"],
["633","140426","黎城县","51"],
["635","140428","长子县","51"],
["636","140429","武乡县","51"],
["638","140431","沁源县","51"],
["639","140481","潞城市","51"],
["640","140501","市辖区","52"],
["641","140502","城区","52"],
["643","140522","阳城县","52"],
["645","140525","泽州县","52"],
["646","140581","高平市","52"],
["647","140601","市辖区","53"],
["648","140602","朔城区","53"],
["650","140621","山阴县","53"],
["651","140622","应县","53"],
["653","140624","怀仁县","53"],
["654","140701","市辖区","54"],
["655","140702","榆次区","54"],
["656","140721","榆社县","54"],
["658","140723","和顺县","54"],
["659","140724","昔阳县","54"],
["661","140726","太谷县","54"],
["662","140727","祁县","54"],
["663","140728","平遥县","54"],
["665","140781","介休市","54"],
["666","140801","市辖区","55"],
["667","140802","盐湖区","55"],
["668","140821","临猗县","55"],
["669","140822","万荣县","55"],
["671","140824","稷山县","55"],
["672","140825","新绛县","55"],
["674","140827","垣曲县","55"],
["675","140828","夏县","55"],
["677","140830","芮城县","55"],
["678","140881","永济市","55"],
["680","140901","市辖区","56"],
["681","140902","忻府区","56"],
["682","140921","定襄县","56"],
["683","140922","五台县","56"],
["684","140923","代县","56"],
["686","140925","宁武县","56"],
["687","140926","静乐县","56"],
["689","140928","五寨县","56"],
["690","140929","岢岚县","56"],
["691","140930","河曲县","56"],
["693","140932","偏关县","56"],
["694","140981","原平市","56"],
["695","141001","市辖区","57"],
["696","141002","尧都区","57"],
["698","141022","翼城县","57"],
["699","141023","襄汾县","57"],
["701","141025","古县","57"],
["702","141026","安泽县","57"],
["703","141027","浮山县","57"],
["705","141029","乡宁县","57"],
["706","141030","大宁县","57"],
["708","141032","永和县","57"],
["709","141033","蒲县","57"],
["710","141034","汾西县","57"],
["712","141082","霍州市","57"],
["713","141101","市辖区","58"],
["714","141102","离石区","58"],
["715","141121","文水县","58"],
["716","141122","交城县","58"],
["717","141123","兴县","58"],
["718","141124","临县","58"],
["719","141125","柳林县","58"],
["720","141126","石楼县","58"],
["721","141127","岚县","58"],
["722","141128","方山县","58"],
["723","141129","中阳县","58"],
["724","141130","交口县","58"],
["725","141181","孝义市","58"],
["726","141182","汾阳市","58"],
["727","150101","市辖区","59"],
["728","150102","新城区","59"],
["729","150103","回民区","59"],
["730","150104","玉泉区","59"],
["731","150105","赛罕区","59"],
["732","150121","土默特左旗","59"],
["733","150122","托克托县","59"],
["734","150123","和林格尔县","59"],
["735","150124","清水河县","59"],
["736","150125","武川县","59"],
["737","150201","市辖区","60"],
["738","150202","东河区","60"],
["739","150203","昆都仑区","60"],
["740","150204","青山区","60"],
["742","150206","白云鄂博矿区","60"],
["743","150207","九原区","60"],
["745","150222","固阳县","60"],
["746","150223","达尔罕茂明安联合旗","60"],
["748","150302","海勃湾区","61"],
["749","150303","海南区","61"],
["751","150401","市辖区","62"],
["752","150402","红山区","62"],
["754","150404","松山区","62"],
["757","150423","巴林右旗","62"],
["758","150424","林西县","62"],
["759","150425","克什克腾旗","62"],
["761","150428","喀喇沁旗","62"],
["762","150429","宁城县","62"],
["763","150430","敖汉旗","62"],
["765","150502","科尔沁区","63"],
["767","150522","科尔沁左翼后旗","63"],
["768","150523","开鲁县","63"],
["769","150524","库伦旗","63"],
["770","150525","奈曼旗","63"],
["772","150581","霍林郭勒市","63"],
["773","150602","东胜区","64"],
["775","150622","准格尔旗","64"],
["776","150623","鄂托克前旗","64"],
["778","150625","杭锦旗","64"],
["779","150626","乌审旗","64"],
["780","150627","伊金霍洛旗","64"],
["782","150702","海拉尔区","65"],
["783","150721","阿荣旗","65"],
["785","150723","鄂伦春自治旗","65"],
["788","150726","新巴尔虎左旗","65"],
["789","150727","新巴尔虎右旗","65"],
["791","150782","牙克石市","65"],
["792","150783","扎兰屯市","65"],
["794","150785","根河市","65"],
["795","150801","市辖区","66"],
["796","150802","临河区","66"],
["797","150821","五原县","66"],
["799","150823","乌拉特前旗","66"],
["800","150824","乌拉特中旗","66"],
["802","150826","杭锦后旗","66"],
["803","150901","市辖区","67"],
["804","150902","集宁区","67"],
["806","150922","化德县","67"],
["807","150923","商都县","67"],
["808","150924","兴和县","67"],
["810","150926","察哈尔右翼前旗","67"],
["812","150928","察哈尔右翼后旗","67"],
["813","150929","四子王旗","67"],
["815","152201","乌兰浩特市","68"],
["816","152202","阿尔山市","68"],
["819","152223","扎赉特旗","68"],
["821","152501","二连浩特市","69"],
["823","152522","阿巴嘎旗","69"],
["824","152523","苏尼特左旗","69"],
["825","152524","苏尼特右旗","69"],
["827","152526","西乌珠穆沁旗","69"],
["828","152527","太仆寺旗","69"],
["830","152529","正镶白旗","69"],
["831","152530","正蓝旗","69"],
["832","152531","多伦县","69"],
["834","152922","阿拉善右旗","70"],
["835","152923","额济纳旗","70"],
["837","210102","和平区","71"],
["838","210103","沈河区","71"],
["839","210104","大东区","71"],
["841","210106","铁西区","71"],
["842","210111","苏家屯区","71"],
["844","210113","沈北新区","71"],
["845","210114","于洪区","71"],
["846","210122","辽中县","71"],
["848","210124","法库县","71"],
["849","210181","新民市","71"],
["851","210202","中山区","72"],
["852","210203","西岗区","72"],
["853","210204","沙河口区","72"],
["854","210211","甘井子区","72"],
["855","210212","旅顺口区","72"],
["856","210213","金州区","72"],
["857","210224","长海县","72"],
["858","210281","瓦房店市","72"],
["859","210282","普兰店市","72"],
["860","210283","庄河市","72"],
["861","210301","市辖区","73"],
["862","210302","铁东区","73"],
["863","210303","铁西区","73"],
["864","210304","立山区","73"],
["865","210311","千山区","73"],
["866","210321","台安县","73"],
["869","210401","市辖区","74"],
["870","210402","新抚区","74"],
["871","210403","东洲区","74"],
["872","210404","望花区","74"],
["873","210411","顺城区","74"],
["875","210422","新宾满族自治县","74"],
["876","210423","清原满族自治县","74"],
["877","210501","市辖区","75"],
["878","210502","平山区","75"],
["879","210503","溪湖区","75"],
["881","210505","南芬区","75"],
["882","210521","本溪满族自治县","75"],
["884","210601","市辖区","76"],
["885","210602","元宝区","76"],
["886","210603","振兴区","76"],
["887","210604","振安区","76"],
["889","210681","东港市","76"],
["890","210682","凤城市","76"],
["891","210701","市辖区","77"],
["892","210702","古塔区","77"],
["893","210703","凌河区","77"],
["894","210711","太和区","77"],
["896","210727","义县","77"],
["897","210781","凌海市","77"],
["899","210801","市辖区","78"],
["900","210802","站前区","78"],
["901","210803","西市区","78"],
["902","210804","鲅鱼圈区","78"],
["903","210811","老边区","78"],
["905","210882","大石桥市","78"],
["906","210901","市辖区","79"],
["907","210902","海州区","79"],
["908","210903","新邱区","79"],
["909","210904","太平区","79"],
["911","210911","细河区","79"],
["913","210922","彰武县","79"],
["914","211001","市辖区","80"],
["915","211002","白塔区","80"],
["916","211003","文圣区","80"],
["917","211004","宏伟区","80"],
["918","211005","弓长岭区","80"],
["920","211021","辽阳县","80"],
["921","211081","灯塔市","80"],
["922","211101","市辖区","81"],
["924","211103","兴隆台区","81"],
["925","211121","大洼县","81"],
["926","211122","盘山县","81"],
["927","211201","市辖区","82"],
["929","211204","清河区","82"],
["930","211221","铁岭县","82"],
["931","211223","西丰县","82"],
["933","211281","调兵山市","82"],
["934","211282","开原市","82"],
["935","211301","市辖区","83"],
["936","211302","双塔区","83"],
["938","211321","朝阳县","83"],
["939","211322","建平县","83"],
["941","211381","北票市","83"],
["942","211382","凌源市","83"],
["943","211401","市辖区","84"],
["1396","331126","庆元县","132"],
["1405","340122","肥东县","133"],
["1410","340203","弋江区","1412"],
["1414","340223","南陵县","1412"],
["1424","340402","大通区","136"],
["1041","230204","铁锋区","95"],
["1043","230206","富拉尔基区","95"],
["1044","230207","碾子山区","95"],
["1046","230221","龙江县","95"],
["1047","230223","依安县","95"],
["1048","230224","泰来县","95"],
["1049","230225","甘南县","95"],
["1050","230227","富裕县","95"],
["1052","230230","克东县","95"],
["1053","230231","拜泉县","95"],
["1054","230281","讷河市","95"],
["1056","230302","鸡冠区","96"],
["1059","230305","梨树区","96"],
["1060","230306","城子河区","96"],
["1061","230307","麻山区","96"],
["1064","230382","密山市","96"],
["1065","230401","市辖区","97"],
["1067","230403","工农区","97"],
["1068","230404","南山区","97"],
["1070","230406","东山区","97"],
["1072","230421","萝北县","97"],
["1074","230501","市辖区","98"],
["1075","230502","尖山区","98"],
["1076","230503","岭东区","98"],
["1078","230506","宝山区","98"],
["1080","230522","友谊县","98"],
["1082","230524","饶河县","98"],
["1083","230601","市辖区","99"],
["1086","230604","让胡路区","99"],
["1087","230605","红岗区","99"],
["1090","230622","肇源县","99"],
["1091","230623","林甸县","99"],
["1093","230701","市辖区","100"],
["1094","230702","伊春区","100"],
["1096","230704","友好区","100"],
["1097","230705","西林区","100"],
["1099","230707","新青区","100"],
["1101","230709","金山屯区","100"],
["1103","230711","乌马河区","100"],
["1106","230714","乌伊岭区","100"],
["1107","230715","红星区","100"],
["1109","230722","嘉荫县","100"],
["1110","230781","铁力市","100"],
["1111","230801","市辖区","101"],
["1113","230803","向阳区","101"],
["1115","230805","东风区","101"],
["1116","230811","郊区","101"],
["1118","230826","桦川县","101"],
["1120","230833","抚远县","101"],
["1122","230882","富锦市","101"],
["1123","230901","市辖区","102"],
["1126","230904","茄子河区","102"],
["1127","230921","勃利县","102"],
["1129","231002","东安区","103"],
["1131","231004","爱民区","103"],
["1133","231024","东宁县","103"],
["1134","231025","林口县","103"],
["1136","231083","海林市","103"],
["1137","231084","宁安市","103"],
["1139","231101","市辖区","104"],
["1140","231102","爱辉区","104"],
["1141","231121","嫩江县","104"],
["1142","231123","逊克县","104"],
["1144","231181","北安市","104"],
["1145","231182","五大连池市","104"],
["1146","231201","市辖区","105"],
["1147","231202","北林区","105"],
["1149","231222","兰西县","105"],
["1150","231223","青冈县","105"],
["1152","231225","明水县","105"],
["1153","231226","绥棱县","105"],
["1154","231281","安达市","105"],
["1156","231283","海伦市","105"],
["1157","232721","呼玛县","106"],
["1158","232722","塔河县","106"],
["1160","310101","黄浦区","107"],
["1161","310103","卢湾区","107"],
["1162","310104","徐汇区","107"],
["1164","310106","静安区","107"],
["1165","310107","普陀区","107"],
["1166","310108","闸北区","107"],
["1167","310109","虹口区","107"],
["1169","310112","闵行区","107"],
["1170","310113","宝山区","107"],
["1171","310114","嘉定区","107"],
["1173","310116","金山区","107"],
["1174","310117","松江区","107"],
["1175","310118","青浦区","107"],
["1177","310120","奉贤区","107"],
["1178","310230","崇明县","108"],
["1179","320101","市辖区","109"],
["1181","320103","白下区","109"],
["1182","320104","秦淮区","109"],
["1183","320105","建邺区","109"],
["1184","320106","鼓楼区","109"],
["1186","320111","浦口区","109"],
["1187","320113","栖霞区","109"],
["1188","320114","雨花台区","109"],
["1425","340403","田家庵区","136"],
["1427","340405","八公山区","136"],
["1428","340406","潘集区","136"],
["1429","340421","凤台县","136"],
["1430","340501","市辖区","137"],
["1431","340502","金家庄区","137"],
["1432","340503","花山区","137"],
["1433","340504","雨山区","137"],
["1434","340521","当涂县","137"],
["1435","340601","市辖区","138"],
["1436","340602","杜集区","138"],
["1437","340603","相山区","138"],
["1438","340604","烈山区","138"],
["1439","340621","濉溪县","138"],
["1440","340701","市辖区","139"],
["1441","340702","铜官山区","139"],
["1442","340703","狮子山区","139"],
["1443","340711","郊区","139"],
["1444","340721","铜陵县","139"],
["1445","340801","市辖区","140"],
["1446","340802","迎江区","140"],
["1447","340803","大观区","140"],
["1448","340811","宜秀区","140"],
["1449","340822","怀宁县","140"],
["1450","340823","枞阳县","140"],
["1451","340824","潜山县","140"],
["1452","340825","太湖县","140"],
["1453","340826","宿松县","140"],
["1454","340827","望江县","140"],
["1455","340828","岳西县","140"],
["1456","340881","桐城市","140"],
["1457","341001","市辖区","141"],
["1458","341002","屯溪区","141"],
["1459","341003","黄山区","141"],
["1460","341004","徽州区","141"],
["1461","341021","歙县","141"],
["1462","341022","休宁县","141"],
["1463","341023","黟县","141"],
["1464","341024","祁门县","141"],
["1465","341101","市辖区","142"],
["1466","341102","琅琊区","142"],
["1467","341103","南谯区","142"],
["1468","341122","来安县","142"],
["1469","341124","全椒县","142"],
["1470","341125","定远县","142"],
["1471","341126","凤阳县","142"],
["1472","341181","天长市","142"],
["1473","341182","明光市","142"],
["1474","341201","市辖区","143"],
["1475","341202","颍州区","143"],
["1476","341203","颍东区","143"],
["1477","341204","颍泉区","143"],
["1478","341221","临泉县","143"],
["1479","341222","太和县","143"],
["1480","341225","阜南县","143"],
["1481","341226","颍上县","143"],
["1482","341282","界首市","143"],
["1483","341301","市辖区","144"],
["1484","341302","埇桥区","144"],
["1485","341321","砀山县","144"],
["1486","341322","萧县","144"],
["1487","341323","灵璧县","144"],
["1488","341324","泗县","144"],
["1489","341401","市辖区","145"],
["1490","341402","居巢区","145"],
["1491","341421","庐江县","145"],
["1492","341422","无为县","145"],
["1493","341423","含山县","145"],
["1494","341424","和县","145"],
["1495","341501","市辖区","146"],
["1496","341502","金安区","146"],
["1497","341503","裕安区","146"],
["1498","341521","寿县","146"],
["1499","341522","霍邱县","146"],
["1500","341523","舒城县","146"],
["1501","341524","金寨县","146"],
["1502","341525","霍山县","146"],
["1503","341601","市辖区","147"],
["1504","341602","谯城区","147"],
["1505","341621","涡阳县","147"],
["1506","341622","蒙城县","147"],
["1507","341623","利辛县","147"],
["1508","341701","市辖区","148"],
["1509","341702","贵池区","148"],
["1510","341721","东至县","148"],
["1511","341722","石台县","148"],
["1512","341723","青阳县","148"],
["1513","341801","市辖区","149"],
["1514","341802","宣州区","149"],
["1515","341821","郎溪县","149"],
["1516","341822","广德县","149"],
["1517","341823","泾县","149"],
["1518","341824","绩溪县","149"],
["1519","341825","旌德县","149"],
["1520","341881","宁国市","149"],
["1521","350101","市辖区","150"],
["1522","350102","鼓楼区","150"],
["1523","350103","台江区","150"],
["1524","350104","仓山区","150"],
["1525","350105","马尾区","150"],
["1526","350111","晋安区","150"],
["1527","350121","闽侯县","150"],
["1528","350122","连江县","150"],
["1529","350123","罗源县","150"],
["1530","350124","闽清县","150"],
["1531","350125","永泰县","150"],
["1532","350128","平潭县","150"],
["1533","350181","福清市","150"],
["1535","350201","市辖区","151"],
["1536","350203","思明区","151"],
["1537","350205","海沧区","151"],
["1538","350206","湖里区","151"],
["1539","350211","集美区","151"],
["1541","350213","翔安区","151"],
["1542","350301","市辖区","152"],
["1543","350302","城厢区","152"],
["1544","350303","涵江区","152"],
["1545","350304","荔城区","152"],
["1546","350305","秀屿区","152"],
["1549","350402","梅列区","153"],
["1550","350403","三元区","153"],
["1548","350401","市辖区","153"],
["1551","350421","明溪县","153"],
["1553","350424","宁化县","153"],
["1554","350425","大田县","153"],
["1555","350426","尤溪县","153"],
["1557","350428","将乐县","153"],
["1558","350429","泰宁县","153"],
["1560","350481","永安市","153"],
["1561","350501","市辖区","154"],
["1562","350502","鲤城区","154"],
["1564","350504","洛江区","154"],
["1565","350505","泉港区","154"],
["1566","350521","惠安县","154"],
["1567","350524","安溪县","154"],
["1569","350526","德化县","154"],
["1570","350527","金门县","154"],
["1572","350582","晋江市","154"],
["1573","350583","南安市","154"],
["1574","350601","市辖区","155"],
["1576","350603","龙文区","155"],
["1577","350622","云霄县","155"],
["1578","350623","漳浦县","155"],
["1580","350625","长泰县","155"],
["1582","350627","南靖县","155"],
["1584","350629","华安县","155"],
["1586","350701","市辖区","156"],
["1587","350702","延平区","156"],
["1590","350723","光泽县","156"],
["1591","350724","松溪县","156"],
["1592","350725","政和县","156"],
["1595","350783","建瓯市","156"],
["1596","350784","建阳市","156"],
["1599","350821","长汀县","157"],
["1600","350822","永定县","157"],
["1603","350825","连城县","157"],
["1604","350881","漳平市","157"],
["1606","350902","蕉城区","158"],
["1608","350922","古田县","158"],
["1610","350924","寿宁县","158"],
["1612","350926","柘荣县","158"],
["1614","350982","福鼎市","158"],
["1615","360101","市辖区","159"],
["1616","360102","东湖区","159"],
["1619","360105","湾里区","159"],
["1621","360121","南昌县","159"],
["1623","360123","安义县","159"],
["1624","360124","进贤县","159"],
["1626","360202","昌江区","160"],
["1628","360222","浮梁县","160"],
["1630","360301","市辖区","161"],
["1631","360302","安源区","161"],
["1634","360322","上栗县","161"],
["1635","360323","芦溪县","161"],
["1636","360401","市辖区","162"],
["1638","360403","浔阳区","162"],
["1640","360423","武宁县","162"],
["1642","360425","永修县","162"],
["1644","360427","星子县","162"],
["1646","360429","湖口县","162"],
["1647","360430","彭泽县","162"],
["1189","320115","江宁区","109"],
["1190","320116","六合区","109"],
["1191","320124","溧水县","109"],
["1192","320125","高淳县","109"],
["1193","320201","市辖区","110"],
["1194","320202","崇安区","110"],
["1195","320203","南长区","110"],
["1196","320204","北塘区","110"],
["1197","320205","锡山区","110"],
["1198","320206","惠山区","110"],
["1199","320211","滨湖区","110"],
["1200","320281","江阴市","110"],
["1201","320282","宜兴市","110"],
["1202","320301","市辖区","111"],
["1203","320302","鼓楼区","111"],
["1204","320303","云龙区","111"],
["1206","320305","贾汪区","111"],
["1207","320311","泉山区","111"],
["1208","320321","丰县","111"],
["1209","320322","沛县","111"],
["1210","320312","铜山区","111"],
["1211","320324","睢宁县","111"],
["1212","320381","新沂市","111"],
["1213","320382","邳州市","111"],
["1214","320401","市辖区","112"],
["1215","320402","天宁区","112"],
["1216","320404","钟楼区","112"],
["1217","320405","戚墅堰区","112"],
["1218","320411","新北区","112"],
["1219","320412","武进区","112"],
["1220","320481","溧阳市","112"],
["1221","320482","金坛市","112"],
["1222","320501","市辖区","113"],
["1223","320502","沧浪区","113"],
["1224","320503","平江区","113"],
["1225","320504","金阊区","113"],
["1226","320505","虎丘区","113"],
["1227","320506","吴中区","113"],
["1228","320507","相城区","113"],
["1229","320581","常熟市","113"],
["1230","320582","张家港市","113"],
["1231","320583","昆山市","113"],
["1232","320584","吴江市","113"],
["1233","320585","太仓市","113"],
["1234","320601","市辖区","114"],
["1235","320602","崇川区","114"],
["1236","320611","港闸区","114"],
["1237","320621","海安县","114"],
["1238","320623","如东县","114"],
["1239","320681","启东市","114"],
["1240","320682","如皋市","114"],
["1241","320612","通州区","114"],
["1242","320684","海门市","114"],
["1243","320701","市辖区","115"],
["1244","320703","连云区","115"],
["1245","320705","新浦区","115"],
["1246","320706","海州区","115"],
["1247","320721","赣榆县","115"],
["1248","320722","东海县","115"],
["1249","320723","灌云县","115"],
["1250","320724","灌南县","115"],
["1251","320801","市辖区","116"],
["1252","320802","清河区","116"],
["1253","320803","楚州区","116"],
["1254","320804","淮阴区","116"],
["1255","320811","清浦区","116"],
["1256","320826","涟水县","116"],
["1257","320829","洪泽县","116"],
["1258","320830","盱眙县","116"],
["1259","320831","金湖县","116"],
["1260","320901","市辖区","117"],
["1261","320902","亭湖区","117"],
["1262","320903","盐都区","117"],
["1263","320921","响水县","117"],
["1264","320922","滨海县","117"],
["1265","320923","阜宁县","117"],
["1266","320924","射阳县","117"],
["1267","320925","建湖县","117"],
["1268","320981","东台市","117"],
["1269","320982","大丰市","117"],
["1270","321001","市辖区","118"],
["1271","321002","广陵区","118"],
["1272","321003","邗江区","118"],
["1273","321011","维扬区","118"],
["1274","321023","宝应县","118"],
["1275","321081","仪征市","118"],
["1276","321084","高邮市","118"],
["1277","321088","江都市","118"],
["1278","321101","市辖区","119"],
["1279","321102","京口区","119"],
["1280","321111","润州区","119"],
["1281","321112","丹徒区","119"],
["1282","321181","丹阳市","119"],
["1283","321182","扬中市","119"],
["1284","321183","句容市","119"],
["1285","321201","市辖区","120"],
["1286","321202","海陵区","120"],
["1287","321203","高港区","120"],
["1288","321281","兴化市","120"],
["1289","321282","靖江市","120"],
["1290","321283","泰兴市","120"],
["1291","321284","姜堰市","120"],
["1292","321301","市辖区","121"],
["1293","321302","宿城区","121"],
["1294","321311","宿豫区","121"],
["1295","321322","沭阳县","121"],
["1296","321323","泗阳县","121"],
["1298","330101","市辖区","122"],
["1299","330102","上城区","122"],
["1300","330103","下城区","122"],
["1302","330105","拱墅区","122"],
["1303","330106","西湖区","122"],
["1304","330108","滨江区","122"],
["1306","330110","余杭区","122"],
["1307","330122","桐庐县","122"],
["1308","330127","淳安县","122"],
["1310","330183","富阳市","122"],
["1311","330185","临安市","122"],
["1312","330201","市辖区","123"],
["1314","330204","江东区","123"],
["1315","330205","江北区","123"],
["1318","330212","鄞州区","123"],
["1319","330225","象山县","123"],
["1320","330226","宁海县","123"],
["1323","330283","奉化市","123"],
["1324","330301","市辖区","124"],
["1326","330303","龙湾区","124"],
["1327","330304","瓯海区","124"],
["1330","330326","平阳县","124"],
["1331","330327","苍南县","124"],
["1334","330381","瑞安市","124"],
["1335","330382","乐清市","124"],
["1336","330401","市辖区","125"],
["1338","330411","秀洲区","125"],
["1340","330424","海盐县","125"],
["1342","330482","平湖市","125"],
["1343","330483","桐乡市","125"],
["1344","330501","市辖区","126"],
["1346","330503","南浔区","126"],
["1348","330522","长兴县","126"],
["1350","330601","市辖区","127"],
["1351","330602","越城区","127"],
["1354","330681","诸暨市","127"],
["1355","330682","上虞市","127"],
["1358","330702","婺城区","128"],
["1359","330703","金东区","128"],
["1360","330723","武义县","128"],
["1362","330727","磐安县","128"],
["1364","330782","义乌市","128"],
["1366","330784","永康市","128"],
["1367","330801","市辖区","129"],
["1368","330802","柯城区","129"],
["1371","330824","开化县","129"],
["1372","330825","龙游县","129"],
["1374","330901","市辖区","130"],
["1376","330903","普陀区","130"],
["1378","330922","嵊泗县","130"],
["1379","331001","市辖区","131"],
["1380","331002","椒江区","131"],
["1383","331021","玉环县","131"],
["1384","331022","三门县","131"],
["1386","331024","仙居县","131"],
["1388","331082","临海市","131"],
["1390","331102","莲都区","132"],
["1391","331121","青田县","132"],
["1394","331124","松阳县","132"],
["1395","331125","云和县","132"],
["1398","331181","龙泉市","132"],
["1399","340101","市辖区","133"],
["1400","340102","瑶海区","133"],
["1401","340103","庐阳区","133"],
["1402","340104","蜀山区","133"],
["1404","340121","长丰县","133"],
["1406","340123","肥西县","133"],
["1408","340202","镜湖区","1412"],
["1409","340208","三山区","1412"],
["1412","340200","芜湖市","134"],
["1413","340222","繁昌县","1412"],
["1415","340301","市辖区","135"],
["1416","340302","龙子湖区","135"],
["1417","340303","蚌山区","135"],
["1418","340304","禹会区","135"],
["1419","340311","淮上区","135"],
["1420","340321","怀远县","135"],
["1421","340322","五河县","135"],
["1422","340323","固镇县","135"],
["1423","340401","市辖区","136"],
["71","210100","沈阳市","7"],
["72","210200","大连市","7"],
["73","210300","鞍山市","7"],
["74","210400","抚顺市","7"],
["75","210500","本溪市","7"],
["76","210600","丹东市","7"],
["77","210700","锦州市","7"],
["78","210800","营口市","7"],
["79","210900","阜新市","7"],
["80","211000","辽阳市","7"],
["81","211100","盘锦市","7"],
["82","211200","铁岭市","7"],
["83","211300","朝阳市","7"],
["84","211400","葫芦岛市","7"],
["85","220100","长春市","8"],
["86","220200","吉林市","8"],
["87","220300","四平市","8"],
["88","220400","辽源市","8"],
["89","220500","通化市","8"],
["90","220600","白山市","8"],
["91","220700","松原市","8"],
["92","220800","白城市","8"],
["93","222400","延边朝鲜族自治州","8"],
["94","230100","哈尔滨市","9"],
["95","230200","齐齐哈尔市","9"],
["96","230300","鸡西市","9"],
["97","230400","鹤岗市","9"],
["98","230500","双鸭山市","9"],
["99","230600","大庆市","9"],
["100","230700","伊春市","9"],
["101","230800","佳木斯市","9"],
["102","230900","七台河市","9"],
["103","231000","牡丹江市","9"],
["104","231100","黑河市","9"],
["105","231200","绥化市","9"],
["106","232700","大兴安岭地区","9"],
["107","310100","市辖区","10"],
["108","310200","县","10"],
["110","320200","无锡市","11"],
["111","320300","徐州市","11"],
["113","320500","苏州市","11"],
["114","320600","南通市","11"],
["115","320700","连云港市","11"],
["117","320900","盐城市","11"],
["118","321000","扬州市","11"],
["119","321100","镇江市","11"],
["121","321300","宿迁市","11"],
["122","330100","杭州市","12"],
["1","中国","中国"],
["2","110000","北京市","1"],
["3","120000","天津市","1"],
["4","130000","河北省","1"],
["5","140000","山西省","1"],
["6","150000","内蒙古自治区","1"],
["8","220000","吉林省","1"],
["9","230000","黑龙江省","1"],
["10","310000","上海市","1"],
["12","330000","浙江省","1"],
["13","340000","安徽省","1"],
["14","350000","福建省","1"],
["16","370000","山东省","1"],
["17","410000","河南省","1"],
["18","420000","湖北省","1"],
["20","440000","广东省","1"],
["251","445200","揭阳市","20"],
["252","445300","云浮市","20"],
["253","450100","南宁市","21"],
["254","450200","柳州市","21"],
["255","450300","桂林市","21"],
["256","450400","梧州市","21"],
["257","450500","北海市","21"],
["258","450600","防城港市","21"],
["259","450700","钦州市","21"],
["260","450800","贵港市","21"],
["261","450900","玉林市","21"],
["262","451000","百色市","21"],
["263","451100","贺州市","21"],
["264","451200","河池市","21"],
["265","451300","来宾市","21"],
["266","451400","崇左市","21"],
["267","460100","海口市","22"],
["268","460200","三亚市","22"],
["269","469000","省直辖县级行政区划","22"],
["270","500100","市辖区","23"],
["271","500200","县","23"],
["273","510100","成都市","24"],
["274","510300","自贡市","24"],
["276","510500","泸州市","24"],
["278","510700","绵阳市","24"],
["279","510800","广元市","24"],
["281","511000","内江市","24"],
["282","511100","乐山市","24"],
["285","511500","宜宾市","24"],
["286","511600","广安市","24"],
["287","511700","达州市","24"],
["288","511800","雅安市","24"],
["21","450000","广西壮族自治区","1"],
["24","510000","四川省","1"],
["26","530000","云南省","1"],
["27","540000","西藏自治区","1"],
["29","620000","甘肃省","1"],
["31","640000","宁夏回族自治区","1"],
["32","650000","新疆维吾尔自治区","1"],
["33","110100","市辖区","2"],
["34","110200","县","2"],
["35","120100","市辖区","3"],
["36","120200","县","3"],
["38","130200","唐山市","4"],
["39","130300","秦皇岛市","4"],
["40","130400","邯郸市","4"],
["42","130600","保定市","4"],
["43","130700","张家口市","4"],
["45","130900","沧州市","4"],
["46","131000","廊坊市","4"],
["48","140100","太原市","5"],
["49","140200","大同市","5"],
["51","140400","长治市","5"],
["52","140500","晋城市","5"],
["54","140700","晋中市","5"],
["55","140800","运城市","5"],
["56","140900","忻州市","5"],
["58","141100","吕梁市","5"],
["59","150100","呼和浩特市","6"],
["60","150200","包头市","6"],
["62","150400","赤峰市","6"],
["64","150600","鄂尔多斯市","6"],
["65","150700","呼伦贝尔市","6"],
["66","150800","巴彦淖尔市","6"],
["67","150900","乌兰察布市","6"],
["68","152200","兴安盟","6"],
["69","152500","锡林郭勒盟","6"],
["124","330300","温州市","12"],
["125","330400","嘉兴市","12"],
["126","330500","湖州市","12"],
["129","330800","衢州市","12"],
["130","330900","舟山市","12"],
["133","340100","合肥市","13"],
["134","340200","芜湖市","13"],
["136","340400","淮南市","13"],
["139","340700","铜陵市","13"],
["140","340800","安庆市","13"],
["143","341200","阜阳市","13"],
["144","341300","宿州市","13"],
["145","341400","巢湖市","13"],
["149","341800","宣城市","13"],
["151","350200","厦门市","14"],
["152","350300","莆田市","14"],
["155","350600","漳州市","14"],
["156","350700","南平市","14"],
["159","360100","南昌市","15"],
["160","360200","景德镇市","15"],
["163","360500","新余市","15"],
["165","360700","赣州市","15"],
["166","360800","吉安市","15"],
["169","361100","上饶市","15"],
["170","370100","济南市","16"],
["173","370400","枣庄市","16"],
["174","370500","东营市","16"],
["177","370800","济宁市","16"],
["178","370900","泰安市","16"],
["179","371000","威海市","16"],
["182","371300","临沂市","16"],
["184","371500","聊城市","16"],
["188","410200","开封市","17"],
["189","410300","洛阳市","17"],
["192","410600","鹤壁市","17"],
["193","410700","新乡市","17"],
["195","410900","濮阳市","17"],
["197","411100","漯河市","17"],
["199","411300","南阳市","17"],
["200","411400","商丘市","17"],
["203","411700","驻马店市","17"],
["204","420100","武汉市","18"],
["3213","610723","洋县","332"],
["207","420500","宜昌市","18"],
["208","420600","襄樊市","18"],
["209","420700","鄂州市","18"],
["211","420900","孝感市","18"],
["212","421000","荆州市","18"],
["214","421200","咸宁市","18"],
["215","421300","随州市","18"],
["217","429000","省直辖县级行政区划","18"],
["218","430100","长沙市","19"],
["219","430200","株洲市","19"],
["220","430300","湘潭市","19"],
["222","430500","邵阳市","19"],
["223","430600","岳阳市","19"],
["225","430800","张家界市","19"],
["226","430900","益阳市","19"],
["227","431000","郴州市","19"],
["229","431200","怀化市","19"],
["230","431300","娄底市","19"],
["232","440100","广州市","20"],
["233","440200","韶关市","20"],
["234","440300","深圳市","20"],
["235","440400","珠海市","20"],
["237","440600","佛山市","20"],
["238","440700","江门市","20"],
["239","440800","湛江市","20"],
["241","441200","肇庆市","20"],
["242","441300","惠州市","20"],
["243","441400","梅州市","20"],
["245","441600","河源市","20"],
["246","441700","阳江市","20"],
["247","441800","清远市","20"],
["249","442000","中山市","20"],
["24901","442000","石岐街道","249"],
["24902","442000","东区街道","249"],
["24903","442000","西区街道","249"],
["24904","442000","南区街道","249"],
["24905","442000","五桂山街道","249"],
["24906","442000","中山港街道","249"],
["24907","442000","黄圃镇","249"],
["24908","442000","南头镇","249"],
["24909","442000","东凤镇","249"],
["24910","442000","阜沙镇","249"],
["24911","442000","小榄镇","249"],
["24912","442000","东升镇","249"],
["24913","442000","古镇镇","249"],
["24914","442000","横栏镇","249"],
["24915","442000","三角镇","249"],
["24916","442000","民众镇","249"],
["24917","442000","南朗镇","249"],
["24918","442000","港口镇","249"],
["24919","442000","大涌镇","249"],
["24920","442000","沙溪镇","249"],
["24921","442000","三乡镇","249"],
["24922","442000","板芙镇","249"],
["24923","442000","神湾镇","249"],
["24924","442000","坦洲镇","249"],
["250","445100","潮州市","20"],
["290","512000","资阳市","24"],
["291","513200","阿坝藏族羌族自治州","24"],
["292","513300","甘孜藏族自治州","24"],
["293","513400","凉山彝族自治州","24"],
["294","520100","贵阳市","25"],
["295","520200","六盘水市","25"],
["296","520300","遵义市","25"],
["297","520400","安顺市","25"],
["298","522200","铜仁地区","25"],
["299","522300","黔西南布依族苗族自治州","25"],
["300","522400","毕节地区","25"],
["302","522700","黔南布依族苗族自治州","25"],
["303","530100","昆明市","26"],
["304","530300","曲靖市","26"],
["305","530400","玉溪市","26"],
["306","530500","保山市","26"],
["307","530600","昭通市","26"],
["308","530700","丽江市","26"],
["309","530800","普洱市","26"],
["310","530900","临沧市","26"],
["311","532300","楚雄彝族自治州","26"],
["312","532500","红河哈尼族彝族自治州","26"],
["313","532600","文山壮族苗族自治州","26"],
["314","532800","西双版纳傣族自治州","26"],
["315","532900","大理白族自治州","26"],
["316","533100","德宏傣族景颇族自治州","26"],
["317","533300","怒江傈僳族自治州","26"],
["318","533400","迪庆藏族自治州","26"],
["319","540100","拉萨市","27"],
["320","542100","昌都地区","27"],
["321","542200","山南地区","27"],
["322","542300","日喀则地区","27"],
["324","542500","阿里地区","27"],
["325","542600","林芝地区","27"],
["326","610100","西安市","28"],
["327","610200","铜川市","28"],
["328","610300","宝鸡市","28"],
["329","610400","咸阳市","28"],
["330","610500","渭南市","28"],
["331","610600","延安市","28"],
["332","610700","汉中市","28"],
["333","610800","榆林市","28"],
["334","610900","安康市","28"],
["335","611000","商洛市","28"],
["336","620100","兰州市","29"],
["337","620200","嘉峪关市","29"],
["338","620300","金昌市","29"],
["339","620400","白银市","29"],
["340","620500","天水市","29"],
["341","620600","武威市","29"],
["342","620700","张掖市","29"],
["343","620800","平凉市","29"],
["344","620900","酒泉市","29"],
["345","621000","庆阳市","29"],
["346","621100","定西市","29"],
["347","621200","陇南市","29"],
["348","622900","临夏回族自治州","29"],
["349","623000","甘南藏族自治州","29"],
["350","630100","西宁市","30"],
["351","632100","海东地区","30"],
["352","632200","海北藏族自治州","30"],
["353","632300","黄南藏族自治州","30"],
["354","632500","海南藏族自治州","30"],
["355","632600","果洛藏族自治州","30"],
["356","632700","玉树藏族自治州","30"],
["357","632800","海西蒙古族藏族自治州","30"],
["358","640100","银川市","31"],
["359","640200","石嘴山市","31"],
["360","640300","吴忠市","31"],
["361","640400","固原市","31"],
["363","650100","乌鲁木齐市","32"],
["364","650200","克拉玛依市","32"],
["365","652100","吐鲁番地区","32"],
["366","652200","哈密地区","32"],
["367","652300","昌吉回族自治州","32"],
["368","652700","博尔塔拉蒙古自治州","32"],
["369","652800","巴音郭楞蒙古自治州","32"],
["370","652900","阿克苏地区","32"],
["371","653000","克孜勒苏柯尔克孜自治州","32"],
["372","653100","喀什地区","32"],
["373","653200","和田地区","32"],
["374","654000","伊犁哈萨克自治州","32"],
["375","654200","塔城地区","32"],
["378","110101","东城区","33"],
["382","110105","朝阳区","33"],
["383","110106","丰台区","33"],
["385","110108","海淀区","33"],
["386","110109","门头沟区","33"],
["388","110112","通州区","33"],
["389","110113","顺义区","33"],
["390","110114","昌平区","33"],
["392","110116","怀柔区","33"],
["393","110117","平谷区","33"],
["395","110229","延庆县","34"],
["396","120101","和平区","35"],
["397","120102","河东区","35"],
["398","120103","河西区","35"],
["399","120104","南开区","35"],
["401","120106","红桥区","35"],
["405","120110","东丽区","35"],
["406","120111","西青区","35"],
["407","120112","津南区","35"],
["409","120114","武清区","35"],
["410","120115","宝坻区","35"],
["412","120223","静海县","36"],
["413","120225","蓟县","36"],
["414","130101","市辖区","37"],
["415","130102","长安区","37"],
["416","130103","桥东区","37"],
["417","130104","桥西区","37"],
["418","130105","新华区","37"],
["419","130107","井陉矿区","37"],
["422","130123","正定县","37"],
["425","130126","灵寿县","37"],
["426","130127","高邑县","37"],
["429","130130","无极县","37"],
["430","130131","平山县","37"],
["432","130133","赵县","37"],
["434","130182","藁城市","37"],
["436","130184","新乐市","37"],
["437","130185","鹿泉市","37"],
["438","130201","市辖区","38"],
["441","130204","古冶区","38"],
["442","130205","开平区","38"],
["444","130208","丰润区","38"],
["445","130223","滦县","38"],
["448","130227","迁西县","38"],
["449","130229","玉田县","38"],
["452","130283","迁安市","38"],
["453","130301","市辖区","39"],
["454","130302","海港区","39"],
["458","130322","昌黎县","39"],
["459","130323","抚宁县","39"],
["460","130324","卢龙县","39"],
["461","130401","市辖区","40"],
["463","130403","丛台区","40"],
["465","130406","峰峰矿区","40"],
["468","130424","成安县","40"],
["469","130425","大名县","40"],
["471","130427","磁县","40"],
["473","130429","永年县","40"],
["474","130430","邱县","40"],
["475","130431","鸡泽县","40"],
["477","130433","馆陶县","40"],
["478","130434","魏县","40"],
["479","130435","曲周县","40"],
["481","130501","市辖区","41"],
["482","130502","桥东区","41"],
["483","130503","桥西区","41"],
["485","130522","临城县","41"],
["486","130523","内丘县","41"],
["487","130524","柏乡县","41"],
["489","130526","任县","41"],
["490","130527","南和县","41"],
["491","130528","宁晋县","41"],
["493","130530","新河县","41"],
["494","130531","广宗县","41"],
["495","130532","平乡县","41"],
["497","130534","清河县","41"],
["498","130535","临西县","41"],
["500","130582","沙河市","41"],
["501","130601","市辖区","42"],
["502","130600","新市区","42"],
["504","130604","南市区","42"],
["505","130621","满城县","42"],
["277","510600","德阳市","24"],
["280","510900","遂宁市","24"],
["283","511300","南充市","24"],
["22","460000","海南省","1"],
["28","610000","陕西省","1"],
["37","130100","石家庄市","4"],
["41","130500","邢台市","4"],
["44","130800","承德市","4"],
["47","131100","衡水市","4"],
["50","140300","阳泉市","5"],
["53","140600","朔州市","5"],
["57","141000","临汾市","5"],
["61","150300","乌海市","6"],
["63","150500","通辽市","6"],
["70","152900","阿拉善盟","6"],
["128","330700","金华市","12"],
["132","331100","丽水市","12"],
["137","340500","马鞍山市","13"],
["141","341000","黄山市","13"],
["147","341600","亳州市","13"],
["154","350500","泉州市","14"],
["158","350900","宁德市","14"],
["162","360400","九江市","15"],
["167","360900","宜春市","15"],
["171","370200","青岛市","16"],
["175","370600","烟台市","16"],
["181","371200","莱芜市","16"],
["185","371600","滨州市","16"],
["190","410400","平顶山市","17"],
["196","411000","许昌市","17"],
["201","411500","信阳市","17"],
["205","420200","黄石市","18"],
["379","110102","西城区","33"],
["384","110107","石景山区","33"],
["387","110111","房山区","33"],
["391","110115","大兴区","33"],
["394","110228","密云县","34"],
["400","120105","河北区","35"],
["404","120116","滨海新区","35"],
["408","120113","北辰区","35"],
["411","120221","宁河县","36"],
["421","130121","井陉县","37"],
["424","130125","行唐县","37"],
["428","130129","赞皇县","37"],
["433","130181","辛集市","37"],
["440","130203","路北区","38"],
["446","130224","滦南县","38"],
["450","130230","唐海县","38"],
["456","130304","北戴河区","39"],
["462","130402","邯山区","40"],
["466","130421","邯郸县","40"],
["470","130426","涉县","40"],
["587","131121","枣强县","47"],
["591","131125","安平县","47"],
["594","131128","阜城县","47"],
["598","140105","小店区","48"],
["601","140108","尖草坪区","48"],
["605","140122","阳曲县","48"],
["611","140211","南郊区","49"],
["614","140222","天镇县","49"],
["617","140225","浑源县","49"],
["624","140321","平定县","50"],
["631","140424","屯留县","51"],
["634","140427","壶关县","51"],
["637","140430","沁县","51"],
["642","140521","沁水县","52"],
["644","140524","陵川县","52"],
["649","140603","平鲁区","53"],
["652","140623","右玉县","53"],
["657","140722","左权县","54"],
["660","140725","寿阳县","54"],
["664","140729","灵石县","54"],
["670","140823","闻喜县","55"],
["673","140826","绛县","55"],
["676","140829","平陆县","55"],
["679","140882","河津市","55"],
["685","140924","繁峙县","56"],
["688","140927","神池县","56"],
["692","140931","保德县","56"],
["697","141021","曲沃县","57"],
["700","141024","洪洞县","57"],
["704","141028","吉县","57"],
["707","141031","隰县","57"],
["711","141081","侯马市","57"],
["868","210381","海城市","73"],
["874","210421","抚顺县","74"],
["880","210504","明山区","75"],
["883","210522","桓仁满族自治县","75"],
["888","210624","宽甸满族自治县","76"],
["895","210726","黑山县","77"],
["898","210782","北镇市","77"],
["904","210881","盖州市","78"],
["910","210905","清河门区","79"],
["1930","410425","郏县","190"],
["912","210921","阜新蒙古族自治县","79"],
["919","211011","太子河区","80"],
["923","211102","双台子区","81"],
["928","211202","银州区","82"],
["932","211224","昌图县","82"],
["937","211303","龙城区","83"],
["940","211324","喀喇沁左翼蒙古族自治县","83"],
["3461","652901","阿克苏市","370"],
["756","150422","巴林左旗","62"],
["817","152221","科尔沁右翼前旗","68"],
["2288","431227","新晃侗族自治县","229"],
["2426","441825","连山壮族瑶族自治县","247"],
["2587","469026","昌江黎族自治县","269"],
["2598","500104","大渡口区","270"],
["2629","500242","酉阳土家族苗族自治县","271"],
["2868","520423","镇宁布依族苗族自治县","297"],
["2990","530825","镇沅彝族哈尼族拉祜族自治县","309"],
["3026","532532","河口瑶族自治县","312"],
["3304","620923","肃北蒙古族自治县","344"],
["3439","652222","巴里坤哈萨克自治县","366"],
["989","220581","梅河口市","89"],
["1426","340404","谢家集区","136"],
["275","510400","攀枝花市","24"],
["323","542400","那曲地区","27"],
["376","654300","阿勒泰地区","32"],
["602","140109","万柏林区","48"],
["755","150421","阿鲁科尔沁旗","62"],
["786","150724","鄂温克族自治旗","65"],
["818","152222","科尔沁右翼中旗","68"],
["867","210323","岫岩满族自治县","73"],
["1898","410204","鼓楼区","188"],
["301","522600","黔东南苗族侗族自治州","25"],
["284","511400","眉山市","24"],
["148","341700","池州市","13"],
["362","640500","中卫市","31"],
["3216","610726","宁强县","332"],
["3220","610730","佛坪县","332"],
["3225","610823","横山县","333"],
["3231","610829","吴堡县","333"],
["3356","630121","大通回族土族自治县","350"],
["3360","632122","民和回族土族自治县","351"],
["3363","632127","化隆回族自治县","351"],
["3366","632222","祁连县","352"],
["3369","632321","同仁县","353"],
["3372","632324","河南蒙古族自治县","353"],
["3377","632525","贵南县","354"],
["3381","632624","达日县","355"],
["3384","632721","玉树县","356"],
["3388","632725","囊谦县","356"],
["3391","632802","德令哈市","357"],
["3399","640121","永宁县","358"],
["3403","640202","大武口区","359"],
["3409","640324","同心县","360"],
["3414","640423","隆德县","361"],
["3419","640521","中宁县","362"],
["3425","650105","水磨沟区","363"],
["3431","650202","独山子区","364"],
["3435","652101","吐鲁番市","365"],
["3438","652201","哈密市","366"],
["3440","652223","伊吾县","366"],
["3444","652323","呼图壁县","367"],
["3448","652328","木垒哈萨克自治县","367"],
["3451","652723","温泉县","368"],
["3454","652823","尉犁县","369"],
["3456","652825","且末县","369"],
["1057","230303","恒山区","96"],
["1063","230381","虎林市","96"],
["1071","230407","兴山区","97"],
["1079","230521","集贤县","98"],
["1084","230602","萨尔图区","99"],
["1089","230621","肇州县","99"],
["1095","230703","南岔区","100"],
["1100","230708","美溪区","100"],
["1104","230712","汤旺河区","100"],
["1114","230804","前进区","101"],
["1119","230828","汤原县","101"],
["1124","230902","新兴区","102"],
["1130","231003","阳明区","103"],
["1135","231081","绥芬河市","103"],
["1138","231085","穆棱市","103"],
["1143","231124","孙吴县","104"],
["1148","231221","望奎县","105"],
["1151","231224","庆安县","105"],
["1155","231282","肇东市","105"],
["1159","232723","漠河县","106"],
["1163","310105","长宁区","107"],
["1168","310110","杨浦区","107"],
["1172","310115","浦东新区","107"],
["1180","320102","玄武区","109"],
["1185","320107","下关区","109"],
["1534","350182","长乐市","150"],
["1540","350212","同安区","151"],
["1547","350322","仙游县","152"],
["1552","350423","清流县","153"],
["1556","350427","沙县","153"],
["1559","350430","建宁县","153"],
["1563","350503","丰泽区","154"],
["1568","350525","永春县","154"],
["1571","350581","石狮市","154"],
["1575","350602","芗城区","155"],
["1579","350624","诏安县","155"],
["1583","350628","平和县","155"],
["1588","350721","顺昌县","156"],
["1594","350782","武夷山市","156"],
["1598","350802","新罗区","157"],
["1602","350824","武平县","157"],
["1607","350921","霞浦县","158"],
["1611","350925","周宁县","158"],
["1618","360104","青云谱区","159"],
["1622","360122","新建县","159"],
["1627","360203","珠山区","160"],
["1632","360313","湘东区","161"],
["1639","360421","九江县","162"],
["1643","360426","德安县","162"],
["1316","330206","北仑区","123"],
["1322","330282","慈溪市","123"],
["1328","330322","洞头县","124"],
["1332","330328","文成县","124"],
["1339","330421","嘉善县","125"],
["1347","330521","德清县","126"],
["1352","330621","绍兴县","127"],
["1356","330683","嵊州市","127"],
["1363","330781","兰溪市","128"],
["1370","330822","常山县","129"],
["1375","330902","定海区","130"],
["1382","331004","路桥区","131"],
["1387","331081","温岭市","131"],
["1392","331122","缙云县","132"],
["4000","620503","麦积区","340"],
["4001","500116","江津区","270"],
["4002","500117","合川区","270"],
["4003","500118","永川区","270"],
["4004","500119","南川区","270"],
["4006","340221","芜湖县","1412"],
["4100","232701","加格达奇区","106"],
["4101","232702","松岭区","106"],
["4102","232703","新林区","106"],
["4103","232704","呼中区","106"],
["4200","330402","南湖区","125"],
["4300","360482","共青城市","162"],
["4400","640303","红寺堡区","360"],
["4500","620922","瓜州县","344"],
["4600","421321","随县","215"],
["4700","431102","零陵区","228"],
["4800","451119","平桂管理区","263"],
["4900","510802","利州区","279"],
["5000","511681","华蓥市","286"],
["377","659000","自治区直辖县级行政区划","32"]
]
}


// WEBPACK FOOTER //
// ./src/static/js/region.js